import Tesseract from "tesseract.js";

import { Link, useParams } from "react-router-dom";
import React, { useState, useEffect, useMemo } from "react";
import {
  Box,
  Typography,
  Stack,
  Card,
  CardContent,
  Grid,
  Button,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
  Tooltip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  CircularProgress,
  Tabs,
  Tab,
  Divider,
  Checkbox,
  FormControlLabel,
  Alert,
  ToggleButton,
  ToggleButtonGroup,
  Autocomplete,
} from "@mui/material";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import AddIcon from "@mui/icons-material/Add";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import SearchIcon from "@mui/icons-material/Search";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import SwitchAccountIcon from "@mui/icons-material/SwitchAccount";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import DownloadIcon from "@mui/icons-material/Download";
import CloseIcon from "@mui/icons-material/Close";
import Avatar from "@mui/material/Avatar";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import PrintIcon from "@mui/icons-material/Print";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import DescriptionIcon from "@mui/icons-material/Description";
import {
  collection,
  onSnapshot,
  doc,
  setDoc,
  updateDoc,
  deleteDoc,
  serverTimestamp,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db, storage } from "../firebase/config";
import { ref, getBlob, getDownloadURL } from "firebase/storage";
import { createAuthUser } from "../firebase/user";
import { openDocumentUrl, getLocalFormFile, getFormFileFromIndexedDB, saveFormFileToIndexedDB } from "./DistripakoBankFormsPage";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import ContractViewerModal from "../components/ContractViewerModal";
import { generatePromosummaFilledPDF, PromosummaClientData } from "../services/promosummaFormService";




const stampFormBodyOverlay = (
  page: any,
  clientCase: CreditCase,
  boldFont: any,
  regularFont: any,
  bankColorRgb: any
) => {
  try {
    const { width, height } = page.getSize();

    const parsedNames = splitNameInCreditos(clientCase.clientName || "");
    const firstName = (clientCase as any).firstName || parsedNames.firstName || "";
    const secondName = (clientCase as any).secondName || parsedNames.secondName || "";
    const firstLastName = (clientCase as any).firstLastName || parsedNames.firstLastName || "";
    const secondLastName = (clientCase as any).secondLastName || parsedNames.secondLastName || "";

    const expDate = clientCase.expeditionDate || "";
    const expPlace = clientCase.expeditionPlace || "";
    const bDate = clientCase.birthDate || "";
    const gen = clientCase.gender || "";
    const rhType = clientCase.rh || "";
    const ccNum = clientCase.documentNumber || "";
    const phone = clientCase.phone || "";
    const email = clientCase.email || "";
    const econ = clientCase.economicActivity || "Empleado";
    const amountStr = `${(clientCase.amount || 0).toLocaleString("es-CO")} COP`;
    const termStr = `${clientCase.termMonths} Meses`;

    const blueText = rgb(0.05, 0.2, 0.65);
    const darkText = rgb(0.1, 0.1, 0.1);

    // 1. MARCA X EN CALIDAD SOLICITANTE: TITULAR
    page.drawText("X", { x: 262, y: height - 148, size: 10, font: boldFont, color: blueText });

    // 2. INFORMACIÓN PERSONAL - NOMBRES DESGLOSADOS (Fila 1)
    page.drawText(firstName.toUpperCase(), { x: 30, y: height - 198, size: 8.5, font: boldFont, color: blueText });
    page.drawText((secondName || "-").toUpperCase(), { x: 135, y: height - 198, size: 8.5, font: boldFont, color: blueText });
    page.drawText(firstLastName.toUpperCase(), { x: 245, y: height - 198, size: 8.5, font: boldFont, color: blueText });
    page.drawText((secondLastName || "-").toUpperCase(), { x: 355, y: height - 198, size: 8.5, font: boldFont, color: blueText });
    page.drawText(email.toLowerCase(), { x: 460, y: height - 198, size: 7.5, font: boldFont, color: blueText });

    // 3. DOCUMENTO DE IDENTIDAD & EXPEDICIÓN (Fila 2)
    page.drawText("X", { x: 48, y: height - 222, size: 9, font: boldFont, color: blueText });
    page.drawText(expPlace.toUpperCase(), { x: 135, y: height - 222, size: 8, font: boldFont, color: blueText });
    page.drawText(ccNum, { x: 275, y: height - 222, size: 9, font: boldFont, color: blueText });
    page.drawText("Soltero(a)", { x: 405, y: height - 222, size: 8, font: regularFont, color: darkText });

    // 4. FECHAS & SEXO (Fila 3)
    page.drawText(expDate, { x: 30, y: height - 246, size: 8, font: boldFont, color: blueText });
    page.drawText(econ, { x: 135, y: height - 246, size: 8, font: regularFont, color: darkText });
    page.drawText(bDate, { x: 275, y: height - 246, size: 8, font: boldFont, color: blueText });
    page.drawText(expPlace, { x: 385, y: height - 246, size: 8, font: regularFont, color: darkText });
    if (gen.startsWith("M") || gen.includes("MASC")) {
      page.drawText("X", { x: 508, y: height - 246, size: 9, font: boldFont, color: blueText });
    } else {
      page.drawText("X", { x: 532, y: height - 246, size: 9, font: boldFont, color: blueText });
    }

    // 5. UBICACIÓN & CONTACTO (Fila 4)
    const addr = (clientCase as any).address || "";
    const cityStr = (clientCase as any).city || "";
    if (addr) page.drawText(addr, { x: 30, y: height - 270, size: 8, font: regularFont, color: darkText });
    if (cityStr) page.drawText(cityStr, { x: 245, y: height - 270, size: 8, font: regularFont, color: darkText });
    page.drawText(phone, { x: 245, y: height - 294, size: 8.5, font: boldFont, color: blueText });

    // 6. INFORMACIÓN LABORAL
    page.drawText("X", { x: 110, y: height - 340, size: 9, font: boldFont, color: blueText });
    if ((clientCase as any).companyName) page.drawText((clientCase as any).companyName, { x: 30, y: height - 362, size: 8, font: regularFont, color: darkText });
    if (econ) page.drawText(econ, { x: 245, y: height - 362, size: 8, font: regularFont, color: darkText });

    // 7. INFORMACIÓN FINANCIERA DEL CRÉDITO A SOLICITAR
    page.drawText(termStr, { x: 30, y: height - 618, size: 9, font: boldFont, color: blueText });
    page.drawText(amountStr, { x: 320, y: height - 618, size: 9.5, font: boldFont, color: rgb(0.02, 0.52, 0.27) });

    // 8. FIRMA Y DATOS DEL SOLICITANTE AL PIE DEL FORMULARIO
    page.drawText(clientCase.clientName, { x: 75, y: height - 765, size: 8.5, font: boldFont, color: blueText });
    page.drawText(ccNum, { x: 75, y: height - 778, size: 8.5, font: boldFont, color: blueText });
  } catch (err) {
    console.warn("Error estampando overlay en cuerpo del formulario:", err);
  }
};


export const fetchWithCorsFallbackBlob = async (url: string): Promise<Blob> => {
  if (!url) throw new Error("URL vacía en fetchWithCorsFallbackBlob");

  if (!url.startsWith("http://") && !url.startsWith("https://")) {
    throw new Error(`La ruta [object Object] no es una URL externa válida.`);
  }

  // 1. Intentar el proxy local de Next.js PRIMERO si es una URL de Firebase Storage (evita error CORS en navegador)
  if (url.includes("firebasestorage.googleapis.com")) {
    try {
      const localProxyUrl = `http://localhost:3000/api/proxy-storage?url=${encodeURIComponent(url)}`;
      const res = await fetch(localProxyUrl);
      if (res.ok) {
        const b = await res.blob();
        if (b.size > 0) return b;
      }
    } catch (e) {
      console.warn("Proxy local Next.js falló:", e);
    }
  }

  try {
    const res = await fetch(url);
    if (res.ok) {
      const b = await res.blob();
      if (b.size > 0) return b;
    }
  } catch (e) {
    console.warn("Fetch directo de HTTP bloqueado por CORS, probando proxies:", e);
  }

  const proxyUrls = [
    `http://localhost:3000/api/proxy-storage?url=${encodeURIComponent(url)}`,
    `/api/proxy-storage?url=${encodeURIComponent(url)}`,
    `https://api.codetabs.com/v1/proxy?quest=${encodeURIComponent(url)}`,
    `https://corsproxy.io/?${encodeURIComponent(url)}`,
    `https://api.allorigins.win/raw?url=${encodeURIComponent(url)}`,
  ];

  for (const proxyUrl of proxyUrls) {
    try {
      const res = await fetch(proxyUrl);
      if (res.ok) {
        const b = await res.blob();
        if (b.size > 0) return b;
      }
    } catch (e) {}
  }

  throw new Error("No se pudo descargar el archivo debido a restricciones de red o CORS.");
};

export const getBlobFromAnyUrl = async (urlOrPath: string): Promise<Blob> => {
  if (!urlOrPath) throw new Error("URL o ruta de archivo vacía.");

  // 1. Buscar en IndexedDB usando múltiples claves potenciales (evita CORS 100%)
  const keysToTry: string[] = [];
  if (urlOrPath.startsWith("indexed_db:")) {
    keysToTry.push(urlOrPath.replace("indexed_db:", ""));
  }
  keysToTry.push(urlOrPath);
  if (urlOrPath.includes("/o/")) {
    const parts = urlOrPath.split("/o/");
    if (parts[1]) {
      const decodedPath = decodeURIComponent(parts[1].split("?")[0]);
      keysToTry.push(decodedPath);
      const filename = decodedPath.split("/").pop();
      if (filename) keysToTry.push(filename);
    }
  } else if (urlOrPath.includes("/")) {
    const filename = urlOrPath.split("/").pop();
    if (filename) keysToTry.push(filename);
  }

  for (const key of keysToTry) {
    try {
      const objUrl = await getFormFileFromIndexedDB(key);
      if (objUrl) {
        const res = await fetch(objUrl);
        if (res.ok) {
          const b = await res.blob();
          if (b.size > 0) return b;
        }
      }
    } catch (e) {}
  }

  // 2. LocalStorage
  if (urlOrPath.startsWith("local_storage:")) {
    const key = urlOrPath.replace("local_storage:", "");
    const local = localStorage.getItem(key);
    if (local && local.startsWith("data:")) {
      const res = await fetch(local);
      return await res.blob();
    }
  }

  // 3. Data URL base64
  if (urlOrPath.startsWith("data:")) {
    const res = await fetch(urlOrPath);
    return await res.blob();
  }

  // 4. Si es una URL HTTP/HTTPS completa con token
  if (urlOrPath.startsWith("http://") || urlOrPath.startsWith("https://")) {
    try {
      console.log(`📥 Intentando fetch directo de URL con token/pública: ${urlOrPath}`);
      const directRes = await fetch(urlOrPath);
      if (directRes.ok) {
        const b = await directRes.blob();
        if (b.size > 0) {
          saveFormFileToIndexedDB(urlOrPath, b);
          return b;
        }
      }
    } catch (directErr) {
      console.warn("Fetch directo de URL falló por CORS, intentando Firebase SDK y proxies fallback:", directErr);
    }
  }

  // 5. Firebase Storage (URL o ruta relativa)
  if (urlOrPath.includes("firebasestorage.googleapis.com") || urlOrPath.startsWith("creditos/") || urlOrPath.startsWith("bancos/")) {
    try {
      let storagePath = urlOrPath;
      if (urlOrPath.includes("/o/")) {
        const parts = urlOrPath.split("/o/");
        if (parts[1]) {
          storagePath = decodeURIComponent(parts[1].split("?")[0]);
        }
      }
      const storageRef = ref(storage, storagePath);

            // 5a. Intentar getDownloadURL de Firebase SDK para obtener la URL firmada con token
      let signedDownloadUrl = "";
      try {
        signedDownloadUrl = await getDownloadURL(storageRef);
        console.log(`📥 URL firmada con token obtenida de Firebase SDK: ${signedDownloadUrl}`);
        const res = await fetch(signedDownloadUrl);
        if (res.ok) {
          const b = await res.blob();
          if (b.size > 0) {
            saveFormFileToIndexedDB(urlOrPath, b);
            saveFormFileToIndexedDB(storagePath, b);
            return b;
          }
        }
      } catch (dlErr) {
        console.warn("Fetch directo de URL firmada bloqueado por CORS, usando proxy local/fallback...", dlErr);
      }

      // 5b. Si tenemos la URL firmada o URL HTTP, intentar proxy CORS local/servidor
      const httpUrlToFetch = signedDownloadUrl || (urlOrPath.startsWith("http") ? urlOrPath : "");
      if (httpUrlToFetch) {
        try {
          console.log(`📥 Intentando descarga mediante proxy local/CORS: ${httpUrlToFetch}`);
          const b = await fetchWithCorsFallbackBlob(httpUrlToFetch);
          if (b && b.size > 0) {
            saveFormFileToIndexedDB(urlOrPath, b);
            saveFormFileToIndexedDB(storagePath, b);
            return b;
          }
        } catch (proxyErr) {
          console.warn("Proxy CORS fallback falló:", proxyErr);
        }
      }

      // 5c. Intentar getBlob del SDK de Firebase Storage como último recurso
      try {
        console.log(`📥 Descargando con Firebase Storage SDK (getBlob): ${storagePath}`);
        const blob = await getBlob(storageRef);
        if (blob && blob.size > 0) {
          saveFormFileToIndexedDB(urlOrPath, blob);
          saveFormFileToIndexedDB(storagePath, blob);
          return blob;
        }
      } catch (sdkErr) {
        console.warn("getBlob de Firebase Storage SDK falló:", sdkErr);
      }
    } catch (err) {
      console.warn("Error procesando recurso de Firebase Storage:", err);
    }
  }

  // 6. Fallback final con Proxies CORS si es URL HTTP/HTTPS
  if (urlOrPath.startsWith("http://") || urlOrPath.startsWith("https://")) {
    return await fetchWithCorsFallbackBlob(urlOrPath);
  }

  throw new Error(`No se pudo descargar ni resolver el archivo: ${urlOrPath}`);
};

export function extractJpegFromPdfBuffer(buffer: ArrayBuffer): string | null {
  try {
    const bytes = new Uint8Array(buffer);
    let startIdx = -1;
    for (let i = 0; i < bytes.length - 3; i++) {
      if (bytes[i] === 0xff && bytes[i + 1] === 0xd8 && bytes[i + 2] === 0xff) {
        startIdx = i;
        break;
      }
    }
    if (startIdx === -1) return null;

    let endIdx = -1;
    for (let i = bytes.length - 2; i > startIdx; i--) {
      if (bytes[i] === 0xff && bytes[i + 1] === 0xd9) {
        endIdx = i + 2;
        break;
      }
    }
    if (endIdx === -1 || endIdx <= startIdx + 100) return null;

    const jpegBytes = bytes.subarray(startIdx, endIdx);
    let binary = "";
    const len = jpegBytes.byteLength;
    const chunkSize = 8192;
    for (let i = 0; i < len; i += chunkSize) {
      const chunk = jpegBytes.subarray(i, Math.min(i + chunkSize, len));
      binary += String.fromCharCode.apply(null, chunk as any);
    }
    return `data:image/jpeg;base64,${btoa(binary)}`;
  } catch (e) {
    console.warn("Could not extract JPEG from PDF buffer:", e);
    return null;
  }
}

export const parseAttachedCedulaDocument = async (fileUrlOrBuffer: string | ArrayBuffer | File | Blob): Promise<Partial<CreditCase>> => {
  try {
    let ocrText = "";
    let pdfRawText = "";
    let targetBlob: Blob | null = null;
    let targetBuffer: ArrayBuffer | null = null;

    if (typeof fileUrlOrBuffer === "string" && fileUrlOrBuffer.length > 0) {
      try {
        targetBlob = await getBlobFromAnyUrl(fileUrlOrBuffer);
        targetBuffer = await targetBlob.arrayBuffer();
      } catch (err) {
        console.warn("Error obteniendo blob para OCR:", err);
      }
    } else if (fileUrlOrBuffer instanceof File || fileUrlOrBuffer instanceof Blob) {
      targetBlob = fileUrlOrBuffer;
      targetBuffer = await fileUrlOrBuffer.arrayBuffer();
    } else if (fileUrlOrBuffer instanceof ArrayBuffer) {
      targetBuffer = fileUrlOrBuffer;
      targetBlob = new Blob([fileUrlOrBuffer]);
    }

    // 0A. Si es una imagen directa (JPG/PNG), enviar a GPT-4o Vision
    if (targetBlob && targetBlob.type && targetBlob.type.startsWith("image/")) {
      try {
        const reader = new FileReader();
        const base64Data = await new Promise<string>((res) => {
          reader.onloadend = () => res((reader.result as string) || "");
          reader.readAsDataURL(targetBlob!);
        });

        if (base64Data) {
          const aiRes = await fetch("http://localhost:3000/api/ai-scan-document", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ imageBase64: base64Data }),
          });

          if (aiRes.ok) {
            const aiJson = await aiRes.json();
            if (aiJson.success && aiJson.data && Object.keys(aiJson.data).length > 0) {
              console.log("⚡ Escaneo GPT-4o Vision (Imagen) completado exitosamente:", aiJson.data);
              return aiJson.data;
            }
          }
        }
      } catch (aiErr) {
        console.warn("Escaneo con GPT-4o Vision omitido para imagen:", aiErr);
      }
    }

    // 0B. Si el archivo es un PDF (CamScanner / Escáner de fotos), extraer la imagen JPEG interna y pasar a GPT-4o Vision
    if (targetBuffer) {
      const extractedJpegBase64 = extractJpegFromPdfBuffer(targetBuffer);
      if (extractedJpegBase64) {
        try {
          console.log("⚡ Imagen JPEG extraída del PDF (CamScanner/Escáner), enviando a GPT-4o Vision...");
          const aiRes = await fetch("http://localhost:3000/api/ai-scan-document", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ imageBase64: extractedJpegBase64 }),
          });

          if (aiRes.ok) {
            const aiJson = await aiRes.json();
            if (aiJson.success && aiJson.data && Object.keys(aiJson.data).length > 0) {
              console.log("⚡ Escaneo GPT-4o Vision desde PDF completado exitosamente:", aiJson.data);
              return aiJson.data;
            }
          }
        } catch (aiErr) {
          console.warn("Escaneo con GPT-4o Vision para PDF de imagen falló:", aiErr);
        }
      }
    }

    // 1. Decodificar stream PDF nativo y limpiar todo código binario interno (endobj, obj, stream, etc.)
    if (targetBuffer) {
      try {
        const bytes = new Uint8Array(targetBuffer);
        const rawDecoded = new TextDecoder("latin1").decode(bytes);
        pdfRawText = rawDecoded
          .replace(/\b(endobj|obj|stream|endstream|xref|trailer|startxref|FlateDecode|catalog|pages|page|font|type|encoding|mediabox|length|filter|contents|index)\b/gi, " ")
          .replace(/\/([A-Z][a-zA-Z0-9]+)/g, " ")
          .replace(/[\x00-\x1F\x7F-\x9F]/g, " ")
          .replace(/\s+/g, " ")
          .trim();
      } catch (e) {}
    }

    // 2. Enviar texto del PDF a GPT-4o para estructuración de datos con IA en JSON
    if (pdfRawText && pdfRawText.length > 20) {
      try {
        const aiRes = await fetch("http://localhost:3000/api/ai-scan-document", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ text: pdfRawText }),
        });

        if (aiRes.ok) {
          const aiJson = await aiRes.json();
          if (aiJson.success && aiJson.data && Object.keys(aiJson.data).length > 0) {
            console.log("⚡ Escaneo GPT-4o del PDF completado exitosamente:", aiJson.data);
            return aiJson.data;
          }
        }
      } catch (aiErr) {
        console.warn("Llamada GPT-4o para PDF falló, usando parser local:", aiErr);
      }
    }

    // 3. Ejecutar Tesseract OCR sobre el Blob (solo si es imagen)
    if (targetBlob && targetBlob.type && targetBlob.type.startsWith("image/")) {
      try {
        const blobUrl = URL.createObjectURL(targetBlob);
        const ocrRes = await Tesseract.recognize(blobUrl, "spa");
        ocrText = ocrRes.data.text || "";
        URL.revokeObjectURL(blobUrl);
      } catch (e) {
        console.warn("Tesseract OCR falló:", e);
      }
    }

    const combinedText = `${pdfRawText}\n${ocrText}`;
    if (!combinedText.trim()) return {};

    const cleanOcr = combinedText.toUpperCase();
    const result: Partial<CreditCase> = {};

    // 1. Número de Cédula (7 a 10 dígitos)
    const ccMatch = cleanOcr.match(/(?:C\.?"?C\.?"?|CEDULA|NUIP|IDENTIFICACION|NUMERO|NO\.?)\s*[:.]?\s*(\d{1,3}(?:\.\d{3}){2,3}|\d{7,10})/i)
                 || cleanOcr.match(/\b([1-9]\d{6,9})\b/);
    if (ccMatch && ccMatch[1]) {
      result.documentNumber = ccMatch[1].replace(/\./g, "").trim();
      result.documentType = "CC";
    }

    // 2. Nombres desglosados
    const nameMatch = cleanOcr.match(/(?:NOMBRES|APELLIDOS|TITULAR|CIUDADANO|SOLICITANTE)\s*[:.]?\s*([A-ZÁÉÍÓÚÑ\s]{5,40})/i);
    if (nameMatch && nameMatch[1]) {
      const parsed = splitNameInCreditos(nameMatch[1].trim());
      result.firstName = parsed.firstName;
      result.secondName = parsed.secondName;
      result.firstLastName = parsed.firstLastName;
      result.secondLastName = parsed.secondLastName;
      result.clientName = parsed.fullName;
    } else {
      const words = cleanOcr.split(/\s+/).filter((w) => w.length > 2 && /^[A-ZÁÉÍÓÚÑ]+$/.test(w));
      const noise = new Set([
        "REPUBLICA", "COLOMBIA", "CEDULA", "CIUDADANIA", "IDENTIFICACION", "PERSONAL", "NACIONAL",
        "FECHA", "LUGAR", "EXPEDICION", "SEXO", "ESTATURA", "STREAM", "OBJECT", "ENDOBJ", "OBJ",
        "ENDSTREAM", "XREF", "TRAILER", "STARTXREF", "FLATEDECODE", "CATALOG", "PAGES", "PAGE",
        "FONT", "TYPE", "ENCODING", "MEDIABOX", "ROTATE", "PARENT", "KIDS", "COUNT", "LENGTH",
        "FILTER", "CONTENTS", "INDEX", "IDENTITY", "UNICODE", "RESOURCE", "RESOURCES"
      ]);
      const cleanWords = words.filter((w) => !noise.has(w) && !/^(endobj|obj|stream|endstream|xref|trailer|flatedecode|catalog|pages|page|font|type|encoding|length|filter)$/i.test(w));
      if (cleanWords.length >= 2) {
        const detectedStr = cleanWords.slice(0, 4).join(" ");
        const parsed = splitNameInCreditos(detectedStr);
        result.firstName = parsed.firstName;
        result.secondName = parsed.secondName;
        result.firstLastName = parsed.firstLastName;
        result.secondLastName = parsed.secondLastName;
        result.clientName = parsed.fullName;
      }
    }

    // 3. Fecha de Expedición
    const expDateMatch = cleanOcr.match(/(?:EXPEDICION|EXPEDIDA|FECHA\s*DE?\s*EXPEDICION|EXP\.?)\s*[:.]?\s*(\d{1,2}[\/\.-]\d{1,2}[\/\.-]\d{4}|\d{4}[\/\.-]\d{1,2}[\/\.-]\d{1,2}|\d{1,2}\s+[A-Z]{3,9}\s+\d{4})/i);
    if (expDateMatch && expDateMatch[1]) {
      result.expeditionDate = expDateMatch[1].trim();
    }

    // 4. Lugar de Expedición
    const expPlaceMatch = cleanOcr.match(/(?:LUGAR\s*(?:DE)?\s*EXPEDICION|EXPEDIDA\s*EN|CIUDAD\s*EXP)\s*[:.]?\s*([A-ZÁÉÍÓÚÑ\s]{3,30})/i);
    if (expPlaceMatch && expPlaceMatch[1]) {
      result.expeditionPlace = expPlaceMatch[1].trim();
    }

    // 5. Fecha de Nacimiento
    const birthMatch = cleanOcr.match(/(?:NACIMIENTO|FECHA\s*(?:DE)?\s*NACIMIENTO|FECHA\s*NAC\.?|NAC\.?)\s*[:.]?\s*(\d{1,2}[\/\.-]\d{1,2}[\/\.-]\d{4}|\d{4}[\/\.-]\d{1,2}[\/\.-]\d{1,2}|\d{1,2}\s+[A-Z]{3,9}\s+\d{4})/i);
    if (birthMatch && birthMatch[1]) {
      result.birthDate = birthMatch[1].trim();
    }

    // 6. Sexo
    const sexMatch = cleanOcr.match(/(?:SEXO|GENERO)\s*[:.]?\s*([MF]|MASCULINO|FEMENINO)/i);
    if (sexMatch && sexMatch[1]) {
      result.gender = sexMatch[1].toUpperCase().startsWith("M") ? "MASCULINO" : "FEMENINO";
    }

    // 7. RH
    const rhMatch = cleanOcr.match(/(?:RH|GS|BLOOD|SANGRE|GRUPO)\s*[:.]?\s*(O\+|O-|A\+|A-|B\+|B-|AB\+|AB-)/i);
    if (rhMatch && rhMatch[1]) {
      result.rh = rhMatch[1].toUpperCase();
    }

    return result;
  } catch (err) {
    console.warn("Error analizando documento con OCR:", err);
    return {};
  }
};

export function calculateEstimatedPayment(amount: number, termMonths: number, monthlyRatePct: number): number {
  if (!amount || !termMonths) return 0;
  const r = (monthlyRatePct || 1.35) / 100;
  if (r === 0) return Math.round(amount / termMonths);
  const payment = (amount * r * Math.pow(1 + r, termMonths)) / (Math.pow(1 + r, termMonths) - 1);
  return Math.round(payment);
}

function splitNameInCreditos(fullName: string) {
  const clean = (fullName || "").replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, "").trim().toUpperCase();
  const parts = clean.split(/\s+/).filter(Boolean);
  let firstName = "", secondName = "", firstLastName = "", secondLastName = "";
  if (parts.length === 1) { firstName = parts[0]; }
  else if (parts.length === 2) { firstName = parts[0]; firstLastName = parts[1]; }
  else if (parts.length === 3) { firstName = parts[0]; firstLastName = parts[1]; secondLastName = parts[2]; }
  else if (parts.length >= 4) { firstName = parts[0]; secondName = parts[1]; firstLastName = parts[2]; secondLastName = parts.slice(3).join(" "); }
  return { firstName, secondName, firstLastName, secondLastName, fullName: [firstName, secondName, firstLastName, secondLastName].filter(Boolean).join(" ") };
}

export interface CreditDocumentItem {
  id: string;
  title: string;
  description?: string;
  required: boolean;
  status: "pendiente" | "en_revision" | "aprobado" | "rechazado";
  fileUrl?: string;
  fileName?: string;
  rejectionReason?: string;
  uploadedAt?: any;
  reviewedAt?: any;
}

export const sanitizeAdminDocumentItem = (docItem: any): CreditDocumentItem => ({
  id: String(docItem?.id || `doc_${Date.now()}`),
  title: String(docItem?.title || "Documento"),
  description: String(docItem?.description || ""),
  required: Boolean(docItem?.required),
  status: ["pendiente", "en_revision", "aprobado", "rechazado"].includes(docItem?.status)
    ? docItem.status
    : "pendiente",
  fileUrl: String(docItem?.fileUrl || ""),
  fileName: String(docItem?.fileName || ""),
  rejectionReason: String(docItem?.rejectionReason || ""),
  uploadedAt: docItem?.uploadedAt ? String(docItem.uploadedAt) : "",
  reviewedAt: docItem?.reviewedAt ? String(docItem.reviewedAt) : "",
});

export interface CreditContractData {
  companyName?: string;
  companyNit?: string;
  repLegalName?: string;
  repLegalDoc?: string;
  city?: string;
  address?: string;
  phone?: string;
  email?: string;
  studyCost?: number;
  studyBankInfo?: string;
  successFeePct?: number;
  successFeeValue?: number;
  preApprovedFeePct?: number;
  preApprovedFeeValue?: number;
  virtualViabilityPct?: number;
  virtualViabilityValue?: number;
  signed?: boolean;
  signatureDataUrl?: string;
  signatureType?: "canvas" | "electronic";
  signedAt?: any;
  signedDateDay?: string;
  signedDateMonth?: string;
  signedDateYear?: string;
  notes?: string;
}

export interface CreditCase {
  id?: string;
  code: string;
  userId: string;
  clientName: string;
  firstName?: string;
  secondName?: string;
  firstLastName?: string;
  secondLastName?: string;
  documentType: string;
  documentNumber: string;
  expeditionDate?: string;
  expeditionPlace?: string;
  birthDate?: string;
  gender?: string;
  rh?: string;
  email: string;
  phone: string;
  city?: string;
  address?: string;
  companyName?: string;
  companyNit?: string;
  economicActivity?: string;
  creditType: string;
  amount: number;
  termMonths: number;
  monthlyInterestRate: number;
  monthlyRate?: number;
  estimatedMonthlyPayment: number;
  status:
    | "estudio_inicial"
    | "documentos_solicitados"
    | "en_revision"
    | "aprobado"
    | "en_desembolso"
    | "desembolsado"
    | "rechazado";
  statusNote?: string;
  documents: CreditDocumentItem[];
  contract?: CreditContractData;
  studyPayment?: {
    cost?: number;
    bankName?: string;
    accountType?: string;
    accountNumber?: string;
    accountNit?: string;
    fileUrl?: string;
    fileName?: string;
    status: "pendiente" | "en_revision" | "verificado" | "rechazado";
    rejectionReason?: string;
    uploadedAt?: any;
    verifiedAt?: any;
  };
  createdAt?: any;
  updatedAt?: any;
}

const statusColors: Record<string, "default" | "warning" | "info" | "success" | "error" | "secondary"> = {
  estudio_inicial: "warning",
  documentos_solicitados: "info",
  en_revision: "secondary",
  aprobado: "success",
  en_desembolso: "info",
  desembolsado: "success",
  rechazado: "error",
};

const statusLabels: Record<string, string> = {
  estudio_inicial: "Estudio Inicial",
  documentos_solicitados: "Documentos Solicitados",
  en_revision: "En Revisión",
  aprobado: "Aprobado",
  en_desembolso: "En Desembolso",
  desembolsado: "Desembolsado",
  rechazado: "Rechazado",
};

const PRESET_TEMPLATES = [
  { id: "cedula", title: "Cédula de Ciudadanía (Ambas caras)", description: "Documento de identidad legible ampliado", required: true },
  { id: "desprendibles", title: "Desprendibles de Nómina (3 últimos meses)", description: "Comprobantes de pago de nómina recientes", required: true },
  { id: "extractos", title: "Extractos Bancarios (3 últimos meses)", description: "Movimientos de cuenta bancaria completos", required: true },
  { id: "laboral", title: "Certificado Laboral Vigente", description: "Antigüedad menor a 30 días con cargo y sueldo", required: false },
  { id: "rut", title: "RUT Actualizado", description: "Para independientes o personas con actividad comercial", required: false },
  { id: "renta", title: "Declaración de Renta", description: "Último periodo gravable o carta de no declarante", required: false },
];

const PROFILES_LIST = [
  { id: "asalariado_empleado", label: "Empleado (Asalariado)" },
  { id: "pensionado", label: "Pensionado" },
  { id: "independiente_prestador", label: "Prestadores de Servicios" },
  { id: "independiente_transportador", label: "Independiente Transportador" },
  { id: "socio_empresa", label: "Socio de Empresa" },
  { id: "rentista_capital", label: "Rentista de Capital" },
  { id: "profesional_independiente", label: "Profesional Independiente" },
  { id: "otros_independientes", label: "Otros Independientes" },
];

export const fillAndDownloadBankPdf = async (
  tplUrl: string,
  clientCase: CreditCase,
  bankName: string,
  tplFileName?: string,
  bankColor?: string
) => {
  try {
    let pdfArrayBuffer: ArrayBuffer | null = null;
    let resolvedUrl = tplUrl;

    const parseBankColor = (hex?: string) => {
      if (!hex || !hex.startsWith("#")) return rgb(0.09, 0.25, 0.68);
      const clean = hex.replace("#", "");
      if (clean.length < 6) return rgb(0.09, 0.25, 0.68);
      const r = parseInt(clean.substring(0, 2), 16) / 255;
      const g = parseInt(clean.substring(2, 4), 16) / 255;
      const b = parseInt(clean.substring(4, 6), 16) / 255;
      return rgb(isNaN(r) ? 0.09 : r, isNaN(g) ? 0.25 : g, isNaN(b) ? 0.68 : b);
    };

    const headerRgb = parseBankColor(bankColor);

    // INTENTAR ESCANEAR DOCUMENTO DE CÉDULA REAL ADJUNTO CON TESSERACT.JS
    let effectiveCase = { ...clientCase };
    const cedulaDoc = (clientCase.documents || []).find((d) => d.fileUrl && (d.title?.toLowerCase().includes("cedula") || d.title?.toLowerCase().includes("documento")));
    if (cedulaDoc && cedulaDoc.fileUrl) {
      try {
        const realOcrData = await parseAttachedCedulaDocument(cedulaDoc.fileUrl);
        if (realOcrData.documentNumber) effectiveCase.documentNumber = realOcrData.documentNumber;
        if (realOcrData.clientName) effectiveCase.clientName = realOcrData.clientName;
        if (realOcrData.firstName) effectiveCase.firstName = realOcrData.firstName;
        if (realOcrData.secondName) effectiveCase.secondName = realOcrData.secondName;
        if (realOcrData.firstLastName) effectiveCase.firstLastName = realOcrData.firstLastName;
        if (realOcrData.secondLastName) effectiveCase.secondLastName = realOcrData.secondLastName;
        if (realOcrData.expeditionDate) effectiveCase.expeditionDate = realOcrData.expeditionDate;
        if (realOcrData.expeditionPlace) effectiveCase.expeditionPlace = realOcrData.expeditionPlace;
        if (realOcrData.birthDate) effectiveCase.birthDate = realOcrData.birthDate;
        if (realOcrData.gender) effectiveCase.gender = realOcrData.gender;
        if (realOcrData.rh) effectiveCase.rh = realOcrData.rh;
      } catch (ocrErr) {
        console.warn("No se pudo extraer OCR automático del adjunto:", ocrErr);
      }
    }

    const parsedNames = splitNameInCreditos(effectiveCase.clientName || "");
    const firstName = (effectiveCase as any).firstName || parsedNames.firstName || "";
    const secondName = (effectiveCase as any).secondName || parsedNames.secondName || "";
    const firstLastName = (effectiveCase as any).firstLastName || parsedNames.firstLastName || "";
    const secondLastName = (effectiveCase as any).secondLastName || parsedNames.secondLastName || "";

    const expDate = effectiveCase.expeditionDate || "";
    const expPlace = effectiveCase.expeditionPlace || "";
    const bDate = effectiveCase.birthDate || "";
    const gen = effectiveCase.gender || "";
    const rhType = effectiveCase.rh || "";

    // 0. ESPECIALIZACIÓN PROMOSUMMA (Plantilla Oficial 3 Páginas AcroForm + Firma Digital)
    if (
      bankName.toLowerCase().includes("promosumma") ||
      (tplFileName && tplFileName.toLowerCase().includes("promosumma")) ||
      (tplUrl && tplUrl.toLowerCase().includes("promosumma"))
    ) {
      const clientPromosummaData: PromosummaClientData = {
        firstName: firstName,
        secondName: secondName,
        firstLastName: firstLastName,
        secondLastName: secondLastName,
        fullName: effectiveCase.clientName || "",
        documentType: effectiveCase.documentType || "CC",
        documentNumber: effectiveCase.documentNumber || "",
        expeditionPlace: expPlace || "MEDELLÍN",
        expeditionDate: expDate || "",
        birthDate: bDate || "",
        gender: gen.toUpperCase().startsWith("F") ? "F" : "M",
        address: (effectiveCase as any).address || "",
        city: (effectiveCase as any).city || "MEDELLÍN",
        department: (effectiveCase as any).department || "ANTIOQUIA",
        cellphone: effectiveCase.phone || "",
        email: effectiveCase.email || "",
        economicActivity: (effectiveCase.economicActivity as any) || "empleado",
        companyName: (effectiveCase as any).companyName || "",
        companyNit: (effectiveCase as any).companyNit || "",
        jobPosition: (effectiveCase as any).jobPosition || "",
        basicSalary: (effectiveCase as any).basicSalary || (effectiveCase as any).monthlyIncome || 0,
        totalIncome: (effectiveCase as any).totalIncome || (effectiveCase as any).monthlyIncome || 0,
        totalExpenses: (effectiveCase as any).totalExpenses || 0,
        loanAmount: effectiveCase.amount || 20000000,
        loanTermMonths: effectiveCase.termMonths || 36,
        signatureBase64: effectiveCase.contract?.signatureDataUrl || "",
        signingCity: (effectiveCase as any).city || "MEDELLÍN",
      };

      const filledBytes = await generatePromosummaFilledPDF(clientPromosummaData);
      const blob = new Blob([filledBytes as any], { type: "application/pdf" });
      const downloadUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = `Solicitud_Promosumma_${(effectiveCase.clientName || "Cliente").replace(/\s+/g, "_")}_${effectiveCase.code || "CRED"}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      return;
    }

    // 1. Intentar cargar el binario del PDF desde la URL o almacenamiento local usando getBlobFromAnyUrl
    if (tplUrl) {
      try {
        const blob = await getBlobFromAnyUrl(tplUrl);
        pdfArrayBuffer = await blob.arrayBuffer();
      } catch (e) {
        console.warn("Error leyendo plantilla PDF del banco:", e);
      }
    }

    // 2. Fallback de localStorage
    if (!pdfArrayBuffer) {
      try {
        const keysInLs = Object.keys(localStorage).filter((k) => k.startsWith("distripako_form_file_"));
        for (const k of keysInLs) {
          const val = localStorage.getItem(k);
          if (val && val.startsWith("data:")) {
            const parts = val.split(",");
            const bstr = atob(parts[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            pdfArrayBuffer = u8arr.buffer;
            console.log(`✅ Formulario cargado desde localStorage fallback key: ${k}`);
            break;
          }
        }
      } catch (e) {
        console.warn("Error buscando en localStorage fallback:", e);
      }
    }

    let pdfDoc: PDFDocument;
    const dateStr = new Date().toLocaleDateString("es-CO");

    if (pdfArrayBuffer) {
      try {
        pdfDoc = await PDFDocument.load(pdfArrayBuffer, { ignoreEncryption: true });
        console.log(`✅ Plantilla oficial de ${bankName} cargada con ${pdfDoc.getPageCount()} página(s).`);
      } catch (loadErr) {
        console.warn("No se pudo parsear el PDF binario existente del banco, generando formato en limpio:", loadErr);
        pdfDoc = await PDFDocument.create();
      }
    } else {
      console.warn("No se encontró archivo de plantilla PDF registrado para el banco. Se creará hoja de radicación de respaldo.");
      pdfDoc = await PDFDocument.create();
    }

    const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
    const regularFont = await pdfDoc.embedFont(StandardFonts.Helvetica);

    // 3. SI EXISTE UNA PLANTILLA DEL BANCO (pdfDoc.getPageCount() > 0)
    if (pdfDoc.getPageCount() > 0) {
      let hasInteractiveAcroForm = false;

      // a. ALGORITMO DE COINCIDENCIA INFALIBLE Y PRIORITARIO PARA CAMPOS ACROFORM
      try {
        const form = pdfDoc.getForm();
        const fields = form.getFields();

        if (fields && fields.length > 0) {
          hasInteractiveAcroForm = true;

          const valuesMap: Record<string, string> = {
            "primer_nombre": firstName,
            "primernombre": firstName,
            "firstname": firstName,
            "first_name": firstName,
            "primer nombre": firstName,
            "1er nombre": firstName,
            "segundo_nombre": secondName,
            "segundonombre": secondName,
            "secondname": secondName,
            "second_name": secondName,
            "segundo nombre": secondName,
            "2do nombre": secondName,
            "primer_apellido": firstLastName,
            "primerapellido": firstLastName,
            "firstlastname": firstLastName,
            "first_last_name": firstLastName,
            "primer apellido": firstLastName,
            "1er apellido": firstLastName,
            "paterno": firstLastName,
            "apellido_paterno": firstLastName,
            "segundo_apellido": secondLastName,
            "segundoapellido": secondLastName,
            "secondlastname": secondLastName,
            "second_last_name": secondLastName,
            "segundo apellido": secondLastName,
            "2do apellido": secondLastName,
            "materno": secondLastName,
            "apellido_materno": secondLastName,
            "fecha_expedicion": expDate,
            "expedicion_fecha": expDate,
            "fechaexpedicion": expDate,
            "exp_fecha": expDate,
            "lugar_expedicion": expPlace,
            "expedicion_lugar": expPlace,
            "lugarexpedicion": expPlace,
            "lugar_exp": expPlace,
            "fecha_nacimiento": bDate,
            "nacimiento_fecha": bDate,
            "fechanacimiento": bDate,
            "genero": gen,
            "sexo": gen,
            "rh": rhType,
            "grupo_sanguineo": rhType,
            "numero_documento": effectiveCase.documentNumber || "",
            "num_documento": effectiveCase.documentNumber || "",
            "cedula": effectiveCase.documentNumber || "",
            "documento": `${effectiveCase.documentType || "C.C."} ${effectiveCase.documentNumber || ""}`,
            "nit": effectiveCase.documentNumber || "",
            "telefono": effectiveCase.phone || "",
            "celular": effectiveCase.phone || "",
            "email": effectiveCase.email || "",
            "correo": effectiveCase.email || "",
            "monto_solicitado": `$${(effectiveCase.amount || 0).toLocaleString("es-CO")} COP`,
            "valor_credito": `$${(effectiveCase.amount || 0).toLocaleString("es-CO")} COP`,
            "monto": `$${(effectiveCase.amount || 0).toLocaleString("es-CO")} COP`,
            "valor": `$${(effectiveCase.amount || 0).toLocaleString("es-CO")} COP`,
            "plazo_meses": `${effectiveCase.termMonths} Meses`,
            "plazo": `${effectiveCase.termMonths} Meses`,
            "tasa": `${effectiveCase.monthlyInterestRate || 1.35}%`,
            "actividad_economica": effectiveCase.economicActivity || "",
            "actividad": effectiveCase.economicActivity || "",
            "ocupacion": effectiveCase.economicActivity || "",
            "nombre_completo": effectiveCase.clientName,
            "solicitante": effectiveCase.clientName,
            "cliente": effectiveCase.clientName,
            "nombre": effectiveCase.clientName,
            "name": effectiveCase.clientName,
            "banco": bankName,
            "fecha": dateStr,
          };

          const sortedKeys = Object.keys(valuesMap).sort((a, b) => b.length - a.length);

          fields.forEach((field) => {
            const fieldName = field.getName().toLowerCase();
            // Ignorar campos de cónyuge, compañero, pareja, codeudor o titular secundario
            if (
              fieldName.includes("conyug") ||
              fieldName.includes("companer") ||
              fieldName.includes("pareja") ||
              fieldName.includes("espos") ||
              fieldName.includes("codeudor") ||
              fieldName.includes("titular_cc") ||
              fieldName.includes("titular_nombre") ||
              fieldName.includes("nombre_titular")
            ) {
              return;
            }

            for (const key of sortedKeys) {
              if (fieldName.includes(key)) {
                try {
                  if ("setText" in field) {
                    (field as any).setText(valuesMap[key]);
                    break;
                  }
                } catch (e) {}
              }
            }
          });

          // Llenado AcroForm completado limpiamente sin contaminar la sección del cónyuge

          try {
            form.updateFieldAppearances(regularFont);
          } catch (e) {
            console.warn("Error actualizando apariencias del formulario:", e);
          }
        }
      } catch (e) {
        console.log("Formulario no posee AcroForm interactivo.");
      }

      // b. Estampar siempre overlay visual de soporte si no se llenaron suficientes campos AcroForm o si es plantilla plana
      const originalFirstPage = pdfDoc.getPages()[0];
      if (originalFirstPage) {
        stampFormBodyOverlay(originalFirstPage, effectiveCase, boldFont, regularFont, headerRgb);
      }

      // c. Insertar Hoja Principal de Portada Resumen
      const coverPage = pdfDoc.insertPage(0, [595.28, 841.89]);

      coverPage.drawRectangle({
        x: 0,
        y: 765,
        width: 595.28,
        height: 76.89,
        color: headerRgb,
      });

      coverPage.drawText(`SOLICITUD Y EXPEDIENTE OFICIAL DE CRÉDITO - ${bankName.toUpperCase()}`, {
        x: 25,
        y: 808,
        size: 13,
        font: boldFont,
        color: rgb(1, 1, 1),
      });

      coverPage.drawText(`Radicado: ${clientCase.code || 'RAD-' + Date.now()} | Banco: ${bankName} | Fecha Radicación: ${dateStr}`, {
        x: 25,
        y: 782,
        size: 9,
        font: regularFont,
        color: rgb(0.95, 0.95, 0.95),
      });

      let y = 725;
      coverPage.drawText("1. DATOS DE IDENTIFICACIÓN DEL SOLICITANTE (NOMBRES SEPARADOS IA)", { x: 25, y, size: 10.5, font: boldFont, color: headerRgb });
      y -= 12;
      coverPage.drawLine({ start: { x: 25, y }, end: { x: 570, y }, thickness: 1, color: rgb(0.8, 0.85, 0.9) });

      y -= 18;
      coverPage.drawText(`Nombre Completo: ${clientCase.clientName}`, { x: 25, y, size: 9.5, font: boldFont, color: rgb(0.1, 0.1, 0.1) });
      coverPage.drawText(`Documento: ${clientCase.documentType || 'C.C.'} ${clientCase.documentNumber || 'N/A'}`, { x: 320, y, size: 9.5, font: boldFont, color: rgb(0.1, 0.1, 0.1) });

      y -= 16;
      coverPage.drawText(`1er Nombre: ${firstName || 'N/A'}`, { x: 25, y, size: 9, font: regularFont, color: rgb(0.3, 0.3, 0.3) });
      coverPage.drawText(`2do Nombre: ${secondName || 'N/A'}`, { x: 160, y, size: 9, font: regularFont, color: rgb(0.3, 0.3, 0.3) });
      coverPage.drawText(`1er Apellido: ${firstLastName || 'N/A'}`, { x: 320, y, size: 9, font: regularFont, color: rgb(0.3, 0.3, 0.3) });
      coverPage.drawText(`2do Apellido: ${secondLastName || 'N/A'}`, { x: 450, y, size: 9, font: regularFont, color: rgb(0.3, 0.3, 0.3) });

      y -= 16;
      coverPage.drawText(`Fecha Expedición: ${expDate}`, { x: 25, y, size: 9, font: regularFont, color: rgb(0.2, 0.2, 0.2) });
      coverPage.drawText(`Lugar Expedición: ${expPlace}`, { x: 160, y, size: 9, font: regularFont, color: rgb(0.2, 0.2, 0.2) });
      coverPage.drawText(`Fecha Nacimiento: ${bDate}`, { x: 320, y, size: 9, font: regularFont, color: rgb(0.2, 0.2, 0.2) });
      coverPage.drawText(`Sexo / RH: ${gen} (${rhType})`, { x: 450, y, size: 9, font: regularFont, color: rgb(0.2, 0.2, 0.2) });

      y -= 16;
      coverPage.drawText(`Teléfono / WhatsApp: ${clientCase.phone || 'N/A'}`, { x: 25, y, size: 9, font: regularFont, color: rgb(0.2, 0.2, 0.2) });
      coverPage.drawText(`Correo (Email): ${clientCase.email || 'N/A'}`, { x: 320, y, size: 9, font: regularFont, color: rgb(0.2, 0.2, 0.2) });

      y -= 16;
      coverPage.drawText(`Actividad Económica: ${clientCase.economicActivity || 'No especificada'}`, { x: 25, y, size: 9, font: regularFont, color: rgb(0.2, 0.2, 0.2) });

      y -= 28;
      coverPage.drawText("2. CONDICIONES FINANCIERAS DE LA SOLICITUD DE CRÉDITO", { x: 25, y, size: 10.5, font: boldFont, color: headerRgb });
      y -= 12;
      coverPage.drawLine({ start: { x: 25, y }, end: { x: 570, y }, thickness: 1, color: rgb(0.8, 0.85, 0.9) });

      y -= 18;
      coverPage.drawText(`Monto Solicitado: $${(clientCase.amount || 0).toLocaleString('es-CO')} COP`, { x: 25, y, size: 9.5, font: boldFont, color: rgb(0.02, 0.52, 0.27) });
      coverPage.drawText(`Plazo Solicitado: ${clientCase.termMonths} Meses`, { x: 320, y, size: 9.5, font: regularFont, color: rgb(0.2, 0.2, 0.2) });

      y -= 16;
      coverPage.drawText(`Tasa de Interés: ${clientCase.monthlyInterestRate || 1.35}% M.V.`, { x: 25, y, size: 9, font: regularFont, color: rgb(0.2, 0.2, 0.2) });
      const estPay = clientCase.estimatedMonthlyPayment || calculateEstimatedPayment(clientCase.amount, clientCase.termMonths, clientCase.monthlyInterestRate || 1.35);
      coverPage.drawText(`Cuota Mensual Estimada: $${estPay.toLocaleString('es-CO')} COP`, { x: 320, y, size: 9, font: boldFont, color: headerRgb });

      y -= 28;
      coverPage.drawText("3. VERIFICACIÓN Y AUDITORÍA DE DOCUMENTOS ANEXADOS", { x: 25, y, size: 10.5, font: boldFont, color: headerRgb });
      y -= 12;
      coverPage.drawLine({ start: { x: 25, y }, end: { x: 570, y }, thickness: 1, color: rgb(0.8, 0.85, 0.9) });

      y -= 18;
      (clientCase.documents || []).forEach((docItem, idx) => {
        const isApproved = docItem.status === 'aprobado';
        const statusText = isApproved ? '[ APROBADO & ANEXADO ]' : `[ ${docItem.status?.toUpperCase() || 'PENDIENTE'} ]`;
        coverPage.drawText(`${idx + 1}. ${docItem.title}`, { x: 30, y, size: 8.5, font: boldFont, color: rgb(0.1, 0.1, 0.1) });
        coverPage.drawText(statusText, { x: 420, y, size: 8.5, font: boldFont, color: isApproved ? rgb(0.02, 0.52, 0.27) : rgb(0.8, 0.4, 0.0) });
        y -= 15;
      });

      coverPage.drawRectangle({
        x: 25,
        y: 40,
        width: 545,
        height: 45,
        color: rgb(0.96, 0.97, 1.0),
        borderColor: headerRgb,
        borderWidth: 1,
      });
      coverPage.drawText(`Expediente Radicado Oficialmente para ${bankName.toUpperCase()} - Distripako AI System`, { x: 35, y: 64, size: 8, font: boldFont, color: headerRgb });
      coverPage.drawText(`Fecha Radicación: ${dateStr} - Formulario Completo y Validado`, { x: 35, y: 50, size: 8, font: regularFont, color: rgb(0.3, 0.3, 0.3) });

      const pages = pdfDoc.getPages();
      pages.forEach((pg, idx) => {
        if (idx > 0) {
          pg.drawText(
            `[EXPEDIENTE UNIFICADO - RADICACIÓN ${bankName.toUpperCase()}] - Hoja ${idx + 1} de ${pages.length} - Cliente: ${clientCase.clientName} - Doc: ${clientCase.documentNumber}`,
            { x: 20, y: 15, size: 7.5, font: regularFont, color: rgb(0.4, 0.4, 0.4) }
          );
        }
      });

    } else {
      // Formato sintético de respaldo si NO existe archivo de formulario guardado para ese banco
      const page = pdfDoc.addPage([595.28, 841.89]);

      page.drawRectangle({
        x: 0,
        y: 765,
        width: 595.28,
        height: 76.89,
        color: headerRgb,
      });

      page.drawText(`SOLICITUD OFICIAL DE CRÉDITO - ${bankName.toUpperCase()}`, {
        x: 30,
        y: 808,
        size: 14,
        font: boldFont,
        color: rgb(1, 1, 1),
      });

      page.drawText(`Radicado: ${clientCase.code || 'RAD-' + Date.now()} | Fecha Radicación: ${dateStr} | Sistema Distripako AI`, {
        x: 30,
        y: 782,
        size: 9,
        font: regularFont,
        color: rgb(0.95, 0.95, 0.95),
      });

      let y = 725;
      page.drawText("1. INFORMACIÓN Y DESGLOSE DEL SOLICITANTE", { x: 30, y, size: 11, font: boldFont, color: headerRgb });
      y -= 12;
      page.drawLine({ start: { x: 30, y }, end: { x: 565, y }, thickness: 1, color: rgb(0.8, 0.85, 0.9) });

      y -= 18;
      page.drawText(`Nombre Completo: ${clientCase.clientName}`, { x: 30, y, size: 10, font: boldFont, color: rgb(0.1, 0.1, 0.1) });
      page.drawText(`Documento: ${clientCase.documentType || 'C.C.'} ${clientCase.documentNumber || 'N/A'}`, { x: 320, y, size: 10, font: boldFont, color: rgb(0.1, 0.1, 0.1) });

      y -= 16;
      page.drawText(`Primer Nombre: ${firstName || 'N/A'}`, { x: 30, y, size: 9, font: regularFont, color: rgb(0.3, 0.3, 0.3) });
      page.drawText(`Segundo Nombre: ${secondName || 'N/A'}`, { x: 170, y, size: 9, font: regularFont, color: rgb(0.3, 0.3, 0.3) });
      page.drawText(`Primer Apellido: ${firstLastName || 'N/A'}`, { x: 320, y, size: 9, font: regularFont, color: rgb(0.3, 0.3, 0.3) });
      page.drawText(`Segundo Apellido: ${secondLastName || 'N/A'}`, { x: 450, y, size: 9, font: regularFont, color: rgb(0.3, 0.3, 0.3) });

      y -= 16;
      page.drawText(`Fecha Expedición: ${expDate}`, { x: 30, y, size: 9, font: regularFont, color: rgb(0.2, 0.2, 0.2) });
      page.drawText(`Lugar Expedición: ${expPlace}`, { x: 170, y, size: 9, font: regularFont, color: rgb(0.2, 0.2, 0.2) });
      page.drawText(`Fecha Nacimiento: ${bDate}`, { x: 320, y, size: 9, font: regularFont, color: rgb(0.2, 0.2, 0.2) });
      page.drawText(`Sexo / RH: ${gen} (${rhType})`, { x: 450, y, size: 9, font: regularFont, color: rgb(0.2, 0.2, 0.2) });

      y -= 16;
      page.drawText(`Teléfono / WhatsApp: ${clientCase.phone || 'N/A'}`, { x: 30, y, size: 9, font: regularFont, color: rgb(0.2, 0.2, 0.2) });
      page.drawText(`Correo (Email): ${clientCase.email || 'N/A'}`, { x: 320, y, size: 9, font: regularFont, color: rgb(0.2, 0.2, 0.2) });

      y -= 16;
      page.drawText(`Actividad Económica: ${clientCase.economicActivity || 'No especificada'}`, { x: 30, y, size: 9, font: regularFont, color: rgb(0.2, 0.2, 0.2) });

      y -= 30;
      page.drawText("2. CONDICIONES FINANCIERAS DE LA SOLICITUD", { x: 30, y, size: 11, font: boldFont, color: headerRgb });
      y -= 12;
      page.drawLine({ start: { x: 30, y }, end: { x: 565, y }, thickness: 1, color: rgb(0.8, 0.85, 0.9) });

      y -= 18;
      page.drawText(`Monto Solicitado: $${(clientCase.amount || 0).toLocaleString('es-CO')} COP`, { x: 30, y, size: 10, font: boldFont, color: rgb(0.02, 0.52, 0.27) });
      page.drawText(`Plazo Solicitado: ${clientCase.termMonths} Meses`, { x: 320, y, size: 10, font: regularFont, color: rgb(0.2, 0.2, 0.2) });

      y -= 16;
      page.drawText(`Tasa de Interés: ${clientCase.monthlyInterestRate || 1.35}% M.V.`, { x: 30, y, size: 9, font: regularFont, color: rgb(0.2, 0.2, 0.2) });
      const estPay = clientCase.estimatedMonthlyPayment || calculateEstimatedPayment(clientCase.amount, clientCase.termMonths, clientCase.monthlyInterestRate || 1.35);
      page.drawText(`Cuota Estimada: $${estPay.toLocaleString('es-CO')} COP`, { x: 320, y, size: 9, font: boldFont, color: headerRgb });

      y -= 30;
      page.drawText("3. CHECKLIST Y ESTADO DE AUDITORÍA DE SOPORTES", { x: 30, y, size: 11, font: boldFont, color: headerRgb });
      y -= 12;
      page.drawLine({ start: { x: 30, y }, end: { x: 565, y }, thickness: 1, color: rgb(0.8, 0.85, 0.9) });

      y -= 18;
      (clientCase.documents || []).forEach((docItem, idx) => {
        const isApproved = docItem.status === 'aprobado';
        const statusText = isApproved ? '[ APROBADO & VERIFICADO ]' : `[ ${docItem.status?.toUpperCase() || 'PENDIENTE'} ]`;
        page.drawText(`${idx + 1}. ${docItem.title}`, { x: 35, y, size: 9, font: boldFont, color: rgb(0.1, 0.1, 0.1) });
        page.drawText(statusText, { x: 420, y, size: 9, font: boldFont, color: isApproved ? rgb(0.02, 0.52, 0.27) : rgb(0.8, 0.4, 0.0) });
        y -= 16;
      });

      page.drawRectangle({
        x: 30,
        y: 40,
        width: 535,
        height: 45,
        color: rgb(0.96, 0.97, 1.0),
        borderColor: headerRgb,
        borderWidth: 1,
      });
      page.drawText(`Expediente Radicado Oficialmente para ${bankName.toUpperCase()} - Distripako AI System`, { x: 40, y: 64, size: 8, font: boldFont, color: headerRgb });
      page.drawText(`Fecha Radicación: ${dateStr} - Verificación y Firma Digital de Soporte OK`, { x: 40, y: 50, size: 8, font: regularFont, color: rgb(0.3, 0.3, 0.3) });
    }

    // 4. LEER Y ANEXAR TODOS LOS DOCUMENTOS DE SOPORTE CARGADOS POR EL USUARIO
    const userDocs = (clientCase.documents || []).filter((d) => d.fileUrl);

    for (const docItem of userDocs) {
      if (!docItem.fileUrl) continue;
      const docUrl = docItem.fileUrl;
      try {
        let docBuffer: ArrayBuffer | null = null;
        try {
          const blob = await getBlobFromAnyUrl(docItem.fileUrl);
          docBuffer = await blob.arrayBuffer();
        } catch (e) {
          console.warn("No se pudo obtener buffer para anexo documental:", e);
        }

        if (docBuffer) {
          try {
            const attachmentPdf = await PDFDocument.load(docBuffer, { ignoreEncryption: true });
            const copiedPages = await pdfDoc.copyPages(attachmentPdf, attachmentPdf.getPageIndices());

            copiedPages.forEach((cpPage) => {
              pdfDoc.addPage(cpPage);
            });
            console.log(`✅ Anexo PDF "${docItem.title}" fusionado exitosamente.`);
          } catch (pdfErr) {
            try {
              let embeddedImg;
              if (docUrl.includes("png") || docUrl.startsWith("data:image/png")) {
                embeddedImg = await pdfDoc.embedPng(docBuffer);
              } else {
                embeddedImg = await pdfDoc.embedJpg(docBuffer);
              }

              if (embeddedImg) {
                const imgPage = pdfDoc.addPage([595.28, 841.89]);

                imgPage.drawText(`ANEXO DE SOPORTE: ${docItem.title.toUpperCase()}`, {
                  x: 30,
                  y: 810,
                  size: 11,
                  font: boldFont,
                  color: headerRgb,
                });

                const dims = embeddedImg.scaleToFit(535, 740);
                imgPage.drawImage(embeddedImg, {
                  x: (595.28 - dims.width) / 2,
                  y: 790 - dims.height,
                  width: dims.width,
                  height: dims.height,
                });
                console.log(`✅ Anexo Imagen "${docItem.title}" incrustado exitosamente.`);
              }
            } catch (imgErr) {
              console.warn("No se pudo incrustar anexo como imagen:", docItem.title, imgErr);
            }
          }
        }
      } catch (docErr) {
        console.warn("Error leyendo documento del usuario:", docItem.title, docErr);
      }
    }

    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    const blobUrl = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = `Expediente_Unificado_${bankName.replace(/\s+/g, "_")}_${clientCase.clientName.replace(/\s+/g, "_")}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } catch (err) {
    console.error("Error al autocompletar el PDF:", err);
    alert("Ocurrió un error al generar el PDF: " + (err as Error).message);
  }
};

export default function DistripakoCreditosPage() {
  const { restaurantId } = useParams<{ restaurantId?: string }>();
  const [cases, setCases] = useState<CreditCase[]>([]);
  const [loading, setLoading] = useState(true);

  // Tabs & Search
  const [currentTab, setCurrentTab] = useState("todas");
  const [searchTerm, setSearchTerm] = useState("");

  // Create Client & Credit Dialog State
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [creating, setCreating] = useState(false);

  // Registered client selection and editable identification state
  const [portalUsers, setPortalUsers] = useState<{ id: string; uid: string; email: string; displayName?: string; documentNumber?: string; phone?: string; documentType?: string }[]>([]);
  const [selectedExistingUser, setSelectedExistingUser] = useState<{ id: string; uid: string; email: string; displayName?: string; documentNumber?: string; phone?: string; documentType?: string } | null>(null);
  const [clientDocType, setClientDocType] = useState("CC");
  const [clientDocNumber, setClientDocNumber] = useState("");
  const [clientPhone, setClientPhone] = useState("");
  const [clientFullName, setClientFullName] = useState("");

  const handleSelectUser = (user: { id: string; uid: string; email: string; displayName?: string; documentNumber?: string; phone?: string; documentType?: string } | null) => {
    setSelectedExistingUser(user);
    if (user) {
      setClientDocType(user.documentType || "CC");
      setClientDocNumber(user.documentNumber || "");
      setClientPhone(user.phone || "");
      setClientFullName(user.displayName || "");
    } else {
      setClientDocType("CC");
      setClientDocNumber("");
      setClientPhone("");
      setClientFullName("");
    }
  };

  const isMissingData = Boolean(
    selectedExistingUser && (!clientDocNumber.trim() || !clientPhone.trim())
  );

  // Form State for new client & credit
  const [newClient, setNewClient] = useState({
    firstName: "",
    secondName: "",
    firstLastName: "",
    secondLastName: "",
    clientName: "",
    documentType: "CC",
    documentNumber: "",
    expeditionDate: "",
    expeditionPlace: "",
    birthDate: "",
    gender: "",
    rh: "",
    phone: "",
    email: "",
    password: "",
    economicActivity: "asalariado_empleado",
    creditType: "libre_inversion",
    amount: 15000000,
    termMonths: 36,
    monthlyRate: 1.35,
    selectedDocs: ["cedula", "desprendibles", "extractos", "laboral"],
  });

  // Matriz General de Requisitos cargada de Firestore
  const [globalMatrix, setGlobalMatrix] = useState<Record<string, string[]>>({
    asalariado_empleado: ["cedula", "certificacion_laboral", "desprendibles_nomina", "certificacion_ingresos_retenciones"],
    pensionado: ["cedula", "certificado_pension", "desprendibles_pension", "extractos_bancarios"],
    independiente_prestador: ["cedula", "contrato", "rut", "declaracion_renta", "extractos_bancarios"],
    independiente_transportador: ["cedula", "rut", "declaracion_renta", "extractos_bancarios", "tarjeta_propiedad_vehiculo", "certificacion_empresa_vehiculo"],
    socio_empresa: ["cedula", "rut", "camara_comercio", "composicion_accionaria", "estados_financieros", "declaracion_renta", "extractos_bancarios", "tarjeta_profesional_contador"],
    rentista_capital: ["cedula", "contratos_arrendamiento", "declaracion_renta", "extractos_bancarios", "rut", "certificacion_tradicion_libertad"],
    profesional_independiente: ["cedula", "declaracion_renta", "rut", "extractos_bancarios"],
    otros_independientes: ["cedula", "camara_comercio", "rut", "declaracion_renta", "extractos_bancarios"],
  });
  const [customDocTypes, setCustomDocTypes] = useState<{ id: string; label: string; description?: string }[]>([]);
  const [economicProfiles, setEconomicProfiles] = useState<{ id: string; label: string }[]>(PROFILES_LIST);
  const DEFAULT_PROMOSUMMA_BANK = {
    id: "promosumma",
    name: "Promosumma S.A.S.",
    code: "PROMOSUMMA",
    color: "#0284c7",
    description: "Solicitud oficial de servicios Promosumma Persona Natural (3 Páginas AcroForm)",
    portalUrl: "http://www.promosumma.com",
    templates: [
      {
        id: "tpl_promosumma_1",
        bankId: "promosumma",
        title: "Solicitud de Servicios Persona Natural (Rev 18/01/22)",
        description: "Formulario oficial de 3 páginas con AcroForm interactivo, autorizaciones centrales y firma digital",
        fileName: "promosumma_persona_natural.pdf",
        fileUrl: "/templates/promosumma_persona_natural.pdf",
        formType: "pdf_acroform",
      },
    ],
  };

  const [banksList, setBanksList] = useState<any[]>([DEFAULT_PROMOSUMMA_BANK]);

  useEffect(() => {
    if (!db) return;
    const docRef = doc(db, "config_general", "bancos_formularios");
    const unsub = onSnapshot(docRef, (snap) => {
      if (snap.exists()) {
        const d = snap.data();
        const mat = d.globalMatrix || undefined;
        const docs = d.documentTypes || undefined;
        if (d.banks && Array.isArray(d.banks) && d.banks.length > 0) {
          const hasPromosumma = d.banks.some((b: any) => b.id === "promosumma");
          setBanksList(hasPromosumma ? d.banks : [DEFAULT_PROMOSUMMA_BANK, ...d.banks]);
        }
        if (d.economicProfiles && Array.isArray(d.economicProfiles) && d.economicProfiles.length > 0) {
          setEconomicProfiles(d.economicProfiles);
        }
        if (mat) setGlobalMatrix(mat);
        if (docs) setCustomDocTypes(docs);
        if (mat) {
          handleEconomicActivityChange(newClient.economicActivity || "asalariado_empleado", mat, docs);
        }
      }
    });
    return () => unsub();
  }, [newClient.economicActivity]);

  const isDocMatched = (matrixDocId: string, itemDocId: string) => {
    if (matrixDocId === itemDocId) return true;
    if (matrixDocId === "certificacion_laboral" && itemDocId === "laboral") return true;
    if (matrixDocId === "laboral" && itemDocId === "certificacion_laboral") return true;

    if (matrixDocId === "desprendibles_nomina" && itemDocId === "desprendibles") return true;
    if (matrixDocId === "desprendibles" && itemDocId === "desprendibles_nomina") return true;

    if (matrixDocId === "extractos_bancarios" && itemDocId === "extractos") return true;
    if (matrixDocId === "extractos" && itemDocId === "extractos_bancarios") return true;

    if (matrixDocId === "declaracion_renta" && itemDocId === "renta") return true;
    if (matrixDocId === "renta" && itemDocId === "declaracion_renta") return true;

    if (matrixDocId === "rut" && itemDocId === "rut_actualizado") return true;
    if (matrixDocId === "rut_actualizado" && itemDocId === "rut") return true;

    return false;
  };

  const handleEconomicActivityChange = (
    newActivity: string,
    matrixOverride?: Record<string, string[]>,
    docsOverride?: { id: string; label: string; description?: string }[]
  ) => {
    const activeMatrix = matrixOverride || globalMatrix;
    const activeDocs = docsOverride || customDocTypes;
    const matrixDocs = activeMatrix[newActivity] || [];
    const selectedIds: string[] = [];

    PRESET_TEMPLATES.forEach((tmpl) => {
      if (matrixDocs.some((mId) => isDocMatched(mId, tmpl.id))) {
        selectedIds.push(tmpl.id);
      }
    });

    activeDocs.forEach((docDef) => {
      if (matrixDocs.some((mId) => isDocMatched(mId, docDef.id))) {
        if (!selectedIds.includes(docDef.id)) {
          selectedIds.push(docDef.id);
        }
      }
    });

    setNewClient((prev) => ({
      ...prev,
      economicActivity: newActivity,
      selectedDocs: selectedIds,
    }));
  };

  useEffect(() => {
    if (openCreateDialog) {
      handleEconomicActivityChange(newClient.economicActivity || "asalariado_empleado");
    }
  }, [openCreateDialog]);

  // Manage / Auditing Dialog State
  const [selectedCase, setSelectedCase] = useState<CreditCase | null>(null);
  const [openDetailDialog, setOpenDetailDialog] = useState(false);
  const [rejectionInput, setRejectionInput] = useState<{ [docId: string]: string }>({});
  const [showRejectField, setShowRejectField] = useState<{ [docId: string]: boolean }>({});
  const [newStatusNote, setNewStatusNote] = useState("");
  const [newCaseStatus, setNewCaseStatus] = useState<CreditCase["status"]>("documentos_solicitados");

  // Auto-fill Bank Form State
  const [selectedTargetBankId, setSelectedTargetBankId] = useState<string>("");
  const [selectedBankTemplateId, setSelectedBankTemplateId] = useState<string>("");
  const [openAutofillDialog, setOpenAutofillDialog] = useState<boolean>(false);
  const [scanningCaseId, setScanningCaseId] = useState<string | null>(null);

  // Contract Viewer Modal State
  const [viewingContractCase, setViewingContractCase] = useState<CreditCase | null>(null);
  const [openContractDialog, setOpenContractDialog] = useState(false);

  const handleOpenContractModal = (c: CreditCase) => {
    setViewingContractCase(c);
    setOpenContractDialog(true);
  };

  const handleScanAndAutofillCaseWithAI = async (creditCase: CreditCase) => {
    if (!creditCase?.id) return;
    setScanningCaseId(creditCase.id);

    try {
      let mergedData: Partial<CreditCase> = {};
      const docsToScan = (creditCase.documents || []).filter((d) => d.fileUrl);

      if (docsToScan.length === 0) {
        alert("El cliente no ha adjuntado soportes documentales todavía.");
        setScanningCaseId(null);
        return;
      }

      for (const docItem of docsToScan) {
        try {
          const ocrData = await parseAttachedCedulaDocument(docItem.fileUrl!);
          if (ocrData.documentNumber) mergedData.documentNumber = ocrData.documentNumber;
          if (ocrData.clientName) mergedData.clientName = ocrData.clientName;
          if (ocrData.firstName) mergedData.firstName = ocrData.firstName;
          if (ocrData.secondName) mergedData.secondName = ocrData.secondName;
          if (ocrData.firstLastName) mergedData.firstLastName = ocrData.firstLastName;
          if (ocrData.secondLastName) mergedData.secondLastName = ocrData.secondLastName;
          if (ocrData.expeditionDate) mergedData.expeditionDate = ocrData.expeditionDate;
          if (ocrData.expeditionPlace) mergedData.expeditionPlace = ocrData.expeditionPlace;
          if (ocrData.birthDate) mergedData.birthDate = ocrData.birthDate;
          if (ocrData.gender) mergedData.gender = ocrData.gender;
          if (ocrData.rh) mergedData.rh = ocrData.rh;
        } catch (e) {
          console.warn("Error leyendo documento:", e);
        }
      }

      if (Object.keys(mergedData).length === 0) {
        alert("No se hallaron campos legibles en los soportes analizados.");
        setScanningCaseId(null);
        return;
      }

      const updatePayload: any = {
        ...mergedData,
        updatedAt: serverTimestamp(),
      };

      await updateDoc(doc(db, "credit_cases", creditCase.id), updatePayload);

      const updatedCaseObj = { ...creditCase, ...mergedData };
      setSelectedCase(updatedCaseObj);

      alert(
        "⚡ ¡EXPEDIENTE PARÁMETRIZADO Y EXTRAÍDO EXITOSAMENTE CON IA!\n\n" +
        `Cliente: ${updatedCaseObj.clientName}\n` +
        `Nombres: ${updatedCaseObj.firstName || ""} ${updatedCaseObj.secondName || ""} ${updatedCaseObj.firstLastName || ""} ${updatedCaseObj.secondLastName || ""}\n` +
        `Cédula: ${updatedCaseObj.documentNumber || "N/A"}\n` +
        `Expedición: ${updatedCaseObj.expeditionDate || "N/A"} (${updatedCaseObj.expeditionPlace || "N/A"})\n` +
        `Nacimiento: ${updatedCaseObj.birthDate || "N/A"}\n` +
        `Sexo/RH: ${updatedCaseObj.gender || "N/A"} (${updatedCaseObj.rh || "N/A"})\n\n` +
        "✅ Los datos se han guardado permanentemente en Firestore y se autocompletarán en las planillas de todos los bancos."
      );
    } catch (err: any) {
      console.error("Error escaneando caso con IA:", err);
      alert("Error al escanear soportes: " + (err.message || err));
    } finally {
      setScanningCaseId(null);
    }
  };

  // Add custom doc in detail dialog
  const [customDocTitle, setCustomDocTitle] = useState("");
  const [customDocDesc, setCustomDocDesc] = useState("");
  const [customDocRequired, setCustomDocRequired] = useState(true);

  // Subscribe to collection "credit_cases"
  useEffect(() => {
    const unsub = onSnapshot(
      collection(db, "credit_cases"),
      (snapshot) => {
        const list = snapshot.docs.map((d) => ({
          id: d.id,
          ...(d.data() as Omit<CreditCase, "id">),
        }));
        list.sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
        setCases(list);
        setLoading(false);
      },
      (err) => {
        console.error("Error subscribing to credit_cases:", err);
        setLoading(false);
      }
    );
    return () => unsub();
  }, []);

  // Sync state when opening detail dialog
  useEffect(() => {
    if (selectedCase) {
      setNewCaseStatus(selectedCase.status);
      setNewStatusNote(selectedCase.statusNote || "");
    }
  }, [selectedCase]);


  // Load registered portal users
  useEffect(() => {
    const loadUsers = async () => {
      try {
        const snap = await getDocs(collection(db, "users"));
        const list = snap.docs
          .map((d) => {
            const data = d.data() as any;
            return {
              id: d.id,
              uid: data.uid || d.id,
              email: data.email || "",
              displayName: data.displayName || data.clientName || data.name || "",
              documentNumber: data.documentNumber || data.cedula || data.documento || "",
              documentType: data.documentType || "CC",
              phone: data.phone || data.phoneNumber || data.telefono || data.celular || "",
              role: data.role || "client",
            };
          })
          .filter((u) => u.email && u.role !== "admin" && u.role !== "superadmin");
        setPortalUsers(list);
      } catch (e) {
        console.error("Error loading portal users:", e);
      }
    };
    if (openCreateDialog) loadUsers();
  }, [openCreateDialog]);

  // KPIs
  const stats = useMemo(() => {
    return {
      total: cases.length,
      estudio: cases.filter((c) => c.status === "estudio_inicial").length,
      solicitados: cases.filter((c) => c.status === "documentos_solicitados").length,
      revision: cases.filter((c) => c.status === "en_revision").length,
      aprobados: cases.filter((c) => c.status === "aprobado").length,
      desembolsados: cases.filter((c) => c.status === "desembolsado").length,
    };
  }, [cases]);

  // Filtered cases
  const filteredCases = useMemo(() => {
    return cases.filter((c) => {
      if (currentTab === "revision" && c.status !== "en_revision") return false;
      if (currentTab === "solicitados" && c.status !== "documentos_solicitados") return false;
      if (currentTab === "aprobados" && c.status !== "aprobado" && c.status !== "en_desembolso") return false;
      if (currentTab === "desembolsados" && c.status !== "desembolsado") return false;

      if (searchTerm.trim()) {
        const t = searchTerm.toLowerCase();
        const matchName = c.clientName?.toLowerCase().includes(t);
        const matchDoc = c.documentNumber?.toLowerCase().includes(t);
        const matchCode = c.code?.toLowerCase().includes(t);
        const matchEmail = c.email?.toLowerCase().includes(t);
        if (!matchName && !matchDoc && !matchCode && !matchEmail) return false;
      }
      return true;
    });
  }, [cases, currentTab, searchTerm]);

  // (Using top-level calculateEstimatedPayment)

  // Create Client & Credit Case
  const handleCreateClientAndCase = async () => {
    if (!selectedExistingUser) {
      alert("Por favor selecciona un cliente registrado en la app / portal.");
      return;
    }
    if (!clientDocNumber.trim()) {
      alert("Por favor ingresa la Cédula / Documento del cliente.");
      return;
    }
    if (!clientPhone.trim()) {
      alert("Por favor ingresa el Teléfono / WhatsApp del cliente.");
      return;
    }
    if (!newClient.amount || Number(newClient.amount) <= 0) {
      alert("Por favor ingresa el monto aproximado solicitado para el estudio.");
      return;
    }

    setCreating(true);
    try {
      const userId = selectedExistingUser.uid || selectedExistingUser.id;
      const finalDocType = clientDocType || "CC";
      const finalDocNumber = clientDocNumber.trim();
      const finalPhone = clientPhone.trim();
      const finalName = clientFullName.trim() || selectedExistingUser.displayName || selectedExistingUser.email;

      // 1. Actualizar de una vez en el perfil del usuario en Firestore (users/{uid})
      await updateDoc(doc(db, "users", userId), {
        documentType: finalDocType,
        documentNumber: finalDocNumber,
        cedula: finalDocNumber,
        documento: finalDocNumber,
        phone: finalPhone,
        phoneNumber: finalPhone,
        telefono: finalPhone,
        celular: finalPhone,
        displayName: finalName,
        clientName: finalName,
        updatedAt: serverTimestamp(),
      });

      // 2. Preparar lista de documentos requeridos según la selección y matriz
      const combinedTemplates = [
        ...PRESET_TEMPLATES,
        ...customDocTypes
          .filter((c) => !PRESET_TEMPLATES.some((p) => isDocMatched(p.id, c.id)))
          .map((c) => ({
            id: c.id,
            title: c.label,
            description: c.description || "Documento configurado en la Matriz General",
            required: true,
          })),
      ];

      const documents: CreditDocumentItem[] = combinedTemplates
        .filter((p) => newClient.selectedDocs.includes(p.id))
        .map((p) => sanitizeAdminDocumentItem({
          id: p.id,
          title: p.title,
          description: p.description || "",
          required: p.required,
          status: "pendiente",
        }));

      // 3. Crear código de radicado
      const randomCode = `CRED-${new Date().getFullYear()}-${Math.floor(1000 + Math.random() * 9000)}`;

      // 4. Crear expediente de crédito en Fase 1 ("estudio_inicial") con pago de estudio $250.000 pendiente
      const caseId = doc(collection(db, "credit_cases")).id;
      await setDoc(doc(db, "credit_cases", caseId), {
        id: caseId,
        code: randomCode,
        userId: userId,
        clientName: finalName,
        documentType: finalDocType,
        documentNumber: finalDocNumber,
        email: selectedExistingUser.email,
        phone: finalPhone,
        economicActivity: newClient.economicActivity || "asalariado_empleado",
        creditType: newClient.creditType || "libre_inversion",
        amount: Number(newClient.amount),
        termMonths: Number(newClient.termMonths),
        monthlyInterestRate: 0,
        estimatedMonthlyPayment: 0,
        status: "estudio_inicial",
        statusNote: "Fase 1: Estudio de Crédito iniciado. Por favor adjunta el comprobante de pago de los $250.000 COP y sube los documentos solicitados.",
        studyPayment: {
          cost: 250000,
          bankName: "BANCOLOMBIA",
          accountType: "Cuenta Corriente",
          accountNumber: "29899994884",
          accountNit: "901500993",
          status: "pendiente",
        },
        documents: documents,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      });

      // 5. Actualizar lista local de portalUsers para reflejar los nuevos datos
      setPortalUsers((prev) =>
        prev.map((u) =>
          u.uid === userId || u.id === userId
            ? { ...u, documentType: finalDocType, documentNumber: finalDocNumber, phone: finalPhone, displayName: finalName }
            : u
        )
      );

      alert(
        `¡Estudio de Crédito Creado Exitosamente!\n` +
        `Radicado: ${randomCode}\n` +
        `Cliente: ${finalName} (${finalDocType} ${finalDocNumber})\n` +
        `Monto Solicitado: $${Number(newClient.amount).toLocaleString("es-CO")} COP\n\n` +
        `Los datos del cliente fueron actualizados en su perfil y el estudio ya está disponible en su portal.`
      );

      setOpenCreateDialog(false);
      setSelectedExistingUser(null);
      setClientDocType("CC");
      setClientDocNumber("");
      setClientPhone("");
      setClientFullName("");
      setNewClient({
        firstName: "",
        secondName: "",
        firstLastName: "",
        secondLastName: "",
        clientName: "",
        documentType: "CC",
        documentNumber: "",
        expeditionDate: "",
        expeditionPlace: "",
        birthDate: "",
        gender: "",
        rh: "",
        phone: "",
        email: "",
        password: "",
        economicActivity: "asalariado_empleado",
        creditType: "libre_inversion",
        amount: 15000000,
        termMonths: 36,
        monthlyRate: 1.35,
        selectedDocs: ["cedula", "desprendibles", "extractos"],
      });
    } catch (err: any) {
      console.error("Error creating credit case:", err);
      alert("Error al crear el caso de crédito: " + (err.message || err));
    } finally {
      setCreating(false);
    }
  };

  // Verify $250.000 study payment
  const handleVerifyStudyPayment = async (creditCase: CreditCase) => {
    if (!creditCase?.id) return;
    try {
      await updateDoc(doc(db, "credit_cases", creditCase.id), {
        "studyPayment.status": "verificado",
        "studyPayment.verifiedAt": serverTimestamp(),
        statusNote: "Comprobante de estudio ($250.000) verificado con éxito. Continuamos con la revisión de tus documentos.",
        updatedAt: serverTimestamp(),
      });
      setSelectedCase((prev) =>
        prev && prev.id === creditCase.id
          ? {
              ...prev,
              studyPayment: prev.studyPayment
                ? { ...prev.studyPayment, status: "verificado", verifiedAt: new Date().toISOString() }
                : { cost: 250000, status: "verificado" },
              statusNote: "Comprobante de estudio ($250.000) verificado con éxito. Continuamos con la revisión de tus documentos.",
            }
          : null
      );
      alert("Pago de estudio ($250.000) verificado exitosamente.");
    } catch (err) {
      console.error("Error verifying study payment:", err);
      alert("Error al verificar el pago de estudio.");
    }
  };

  // Reject $250.000 study payment
  const handleRejectStudyPayment = async (creditCase: CreditCase) => {
    if (!creditCase?.id) return;
    const reason = prompt("Indica el motivo de rechazo del comprobante de pago:") || "Comprobante ilegible o no corresponde al valor.";
    try {
      await updateDoc(doc(db, "credit_cases", creditCase.id), {
        "studyPayment.status": "rechazado",
        "studyPayment.rejectionReason": reason,
        statusNote: `Comprobante de pago rechazado: ${reason}. Por favor sube un comprobante válido.`,
        updatedAt: serverTimestamp(),
      });
      setSelectedCase((prev) =>
        prev && prev.id === creditCase.id
          ? {
              ...prev,
              studyPayment: prev.studyPayment
                ? { ...prev.studyPayment, status: "rechazado", rejectionReason: reason }
                : { cost: 250000, status: "rechazado", rejectionReason: reason },
              statusNote: `Comprobante de pago rechazado: ${reason}. Por favor sube un comprobante válido.`,
            }
          : null
      );
      alert("Comprobante marcado como rechazado.");
    } catch (err) {
      console.error("Error rejecting study payment:", err);
      alert("Error al rechazar el comprobante.");
    }
  };

  // Update Status & Note for credit case
  const handleUpdateCaseStatus = async () => {
    if (!selectedCase?.id) return;
    try {
      await updateDoc(doc(db, "credit_cases", selectedCase.id), {
        status: newCaseStatus,
        statusNote: newStatusNote,
        updatedAt: serverTimestamp(),
      });
      setSelectedCase((prev) => (prev ? { ...prev, status: newCaseStatus, statusNote: newStatusNote } : null));
      alert("Estado del crédito actualizado correctamente.");
    } catch (err) {
      console.error("Error updating case status:", err);
      alert("Error al actualizar estado");
    }
  };

  // Approve a single document
  const handleApproveDocument = async (docId: string) => {
    if (!selectedCase?.id) return;
    try {
      const updatedDocs = (selectedCase.documents || []).map((d) =>
        sanitizeAdminDocumentItem(
          d.id === docId
            ? {
                ...d,
                status: "aprobado",
                rejectionReason: "",
                reviewedAt: new Date().toISOString(),
              }
            : d
        )
      );

      await updateDoc(doc(db, "credit_cases", selectedCase.id), {
        documents: updatedDocs,
        updatedAt: serverTimestamp(),
      });
      setSelectedCase((prev) => (prev ? { ...prev, documents: updatedDocs } : null));
    } catch (err) {
      console.error("Error approving doc:", err);
      alert("Error al aprobar documento");
    }
  };

  // Bulk approve all uploaded documents and transition case to "en_revision"
  const handleAcceptAllAndMoveToReview = async () => {
    if (!selectedCase?.id) return;
    try {
      const updatedDocs = (selectedCase.documents || []).map((d) =>
        sanitizeAdminDocumentItem(
          d.fileUrl
            ? {
                ...d,
                status: "aprobado",
                rejectionReason: "",
                reviewedAt: new Date().toISOString(),
              }
            : d
        )
      );

      const note = "Todos los documentos requeridos fueron aceptados por el equipo administrativo. El expediente avanza a fase de Revisión y Análisis Financiero.";

      await updateDoc(doc(db, "credit_cases", selectedCase.id), {
        documents: updatedDocs,
        status: "en_revision",
        statusNote: note,
        updatedAt: serverTimestamp(),
      });

      setSelectedCase((prev) =>
        prev
          ? {
              ...prev,
              documents: updatedDocs,
              status: "en_revision",
              statusNote: note,
            }
          : null
      );
      setNewCaseStatus("en_revision");
      setNewStatusNote(note);

      alert("✅ ¡Éxito! Todos los documentos subidos han sido aceptados y el caso pasó a estado 'En Revisión'.");
    } catch (err) {
      console.error("Error al aceptar documentos y avanzar a revisión:", err);
      alert("Error al actualizar los documentos y el estado.");
    }
  };

  // Quick start review directly from table
  const handleQuickStartReview = async (c: CreditCase) => {
    if (!c.id) return;
    try {
      const updatedDocs = (c.documents || []).map((d) =>
        sanitizeAdminDocumentItem(
          d.fileUrl
            ? {
                ...d,
                status: "aprobado",
                rejectionReason: "",
                reviewedAt: new Date().toISOString(),
              }
            : d
        )
      );

      const note = "Todos los documentos requeridos fueron aceptados por el equipo administrativo. El expediente avanza a fase de Revisión y Análisis Financiero.";

      await updateDoc(doc(db, "credit_cases", c.id), {
        documents: updatedDocs,
        status: "en_revision",
        statusNote: note,
        updatedAt: serverTimestamp(),
      });

      alert(`✅ ¡Expediente ${c.code} puesto en fase "En Revisión" exitosamente!`);
    } catch (err) {
      console.error("Error al iniciar revisión:", err);
      alert("Error al actualizar estado del caso.");
    }
  };

  // Reject a single document with reason
  const handleRejectDocument = async (docId: string) => {
    if (!selectedCase?.id) return;
    const reason = rejectionInput[docId] || "El documento no es legible o no cumple los requisitos.";

    try {
      const updatedDocs = (selectedCase.documents || []).map((d) =>
        sanitizeAdminDocumentItem(
          d.id === docId
            ? {
                ...d,
                status: "rechazado",
                rejectionReason: reason,
                reviewedAt: new Date().toISOString(),
              }
            : d
        )
      );

      await updateDoc(doc(db, "credit_cases", selectedCase.id), {
        documents: updatedDocs,
        updatedAt: serverTimestamp(),
      });
      setSelectedCase((prev) => (prev ? { ...prev, documents: updatedDocs } : null));
      setShowRejectField((p) => ({ ...p, [docId]: false }));
    } catch (err) {
      console.error("Error rejecting doc:", err);
      alert("Error al rechazar documento");
    }
  };

  // Add custom requested document
  const handleAddCustomDocument = async () => {
    if (!selectedCase?.id || !customDocTitle.trim()) {
      alert("Ingresa el título del documento.");
      return;
    }

    try {
      const newDocItem: CreditDocumentItem = sanitizeAdminDocumentItem({
        id: `custom_${Date.now()}`,
        title: customDocTitle.trim(),
        description: customDocDesc.trim(),
        required: customDocRequired,
        status: "pendiente",
      });

      const updatedDocs = [...(selectedCase.documents || []), newDocItem].map(sanitizeAdminDocumentItem);
      await updateDoc(doc(db, "credit_cases", selectedCase.id), {
        documents: updatedDocs,
        updatedAt: serverTimestamp(),
      });

      setSelectedCase((prev) => (prev ? { ...prev, documents: updatedDocs } : null));
      setCustomDocTitle("");
      setCustomDocDesc("");
    } catch (err) {
      console.error("Error adding custom doc:", err);
      alert("Error al agregar documento");
    }
  };

  // Delete case
  const handleDeleteCase = async (id: string) => {
    if (window.confirm("¿Seguro que deseas eliminar permanentemente este expediente de crédito?")) {
      try {
        await deleteDoc(doc(db, "credit_cases", id));
        if (openDetailDialog) setOpenDetailDialog(false);
      } catch (err) {
        console.error("Error deleting case:", err);
      }
    }
  };

  // WhatsApp helper
  const openWhatsApp = (c: CreditCase) => {
    const clean = (c.phone || "").replace(/\D/g, "");
    const phone = clean.startsWith("57") ? clean : `57${clean}`;
    const msg = `Hola ${c.clientName}, te contactamos de Grupo Next respecto a tu solicitud de crédito ${c.code}. Queremos informarte que tu solicitud se encuentra en estado: "${statusLabels[c.status]}". Puedes ingresar a tu Portal de Clientes para revisar los detalles.`;
    window.open(`https://wa.me/${phone}?text=${encodeURIComponent(msg)}`, "_blank");
  };

  return (
    <Box sx={{ p: 3, maxWidth: 1350, mx: "auto" }}>
      {/* Header */}
      <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems={{ sm: "center" }} gap={2} mb={3}>
        <Box>
          <Typography variant="h5" fontWeight={800} display="flex" alignItems="center" gap={1.5}>
            <CreditCardIcon color="primary" sx={{ fontSize: 32 }} />
            Gestión de Créditos & Clientes
          </Typography>
          <Typography variant="body2" color="text.secondary" mt={0.5}>
            Crea cuentas de cliente, solicita soportes documentales, audita archivos subidos y administra el estado de los créditos.
          </Typography>
        </Box>

        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => {
            setSelectedExistingUser(null);
            setClientDocType("CC");
            setClientDocNumber("");
            setClientPhone("");
            setClientFullName("");
            setOpenCreateDialog(true);
          }}
          sx={{ borderRadius: 2, fontWeight: 800, px: 3 }}
        >
          Nuevo Crédito / Estudio
        </Button>
      </Stack>

      {/* KPI Cards */}
      <Grid container spacing={2} mb={3}>
        <Grid size={{ xs: 6, sm: 4, md: 2 }}>
          <Card sx={{ borderRadius: 3, border: "1px solid #e2e8f0" }}>
            <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
              <Typography variant="caption" color="text.secondary" fontWeight={700}>TOTAL EXPEDIENTES</Typography>
              <Typography variant="h5" fontWeight={900}>{stats.total}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid size={{ xs: 6, sm: 4, md: 2 }}>
          <Card sx={{ borderRadius: 3, border: "1px solid #bae6fd", bgcolor: "#f0f9ff" }}>
            <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
              <Typography variant="caption" color="#0369a1" fontWeight={700}>DOCS. SOLICITADOS</Typography>
              <Typography variant="h5" fontWeight={900} color="#0284c7">{stats.solicitados}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid size={{ xs: 6, sm: 4, md: 2 }}>
          <Card sx={{ borderRadius: 3, border: "1px solid #e9d5ff", bgcolor: "#faf5ff" }}>
            <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
              <Typography variant="caption" color="#7e22ce" fontWeight={700}>🔍 EN REVISIÓN</Typography>
              <Typography variant="h5" fontWeight={900} color="#6b21a8">{stats.revision}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid size={{ xs: 6, sm: 4, md: 2 }}>
          <Card sx={{ borderRadius: 3, border: "1px solid #bbf7d0", bgcolor: "#f0fdf4" }}>
            <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
              <Typography variant="caption" color="#166534" fontWeight={700}>🟢 APROBADOS</Typography>
              <Typography variant="h5" fontWeight={900} color="#15803d">{stats.aprobados}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid size={{ xs: 6, sm: 4, md: 2 }}>
          <Card sx={{ borderRadius: 3, border: "1px solid #a7f3d0", bgcolor: "#ecfdf5" }}>
            <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
              <Typography variant="caption" color="#065f46" fontWeight={700}>💰 DESEMBOLSADOS</Typography>
              <Typography variant="h5" fontWeight={900} color="#047857">{stats.desembolsados}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid size={{ xs: 6, sm: 4, md: 2 }}>
          <Card sx={{ borderRadius: 3, border: "1px solid #fef08a", bgcolor: "#fefce8" }}>
            <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
              <Typography variant="caption" color="#854d0e" fontWeight={700}>ESTUDIO INICIAL</Typography>
              <Typography variant="h5" fontWeight={900} color="#a16207">{stats.estudio}</Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Main Table Card */}
      <Card sx={{ borderRadius: 3, border: "1px solid #e2e8f0" }}>
        <Box sx={{ p: 2.5, borderBottom: "1px solid #e2e8f0" }}>
          <Stack direction={{ xs: "column", md: "row" }} justifyContent="space-between" spacing={2} alignItems={{ md: "center" }}>
            <Tabs
              value={currentTab}
              onChange={(_, val) => setCurrentTab(val)}
              variant="scrollable"
              scrollButtons="auto"
              sx={{ minHeight: 40 }}
            >
              <Tab label={`Todos (${cases.length})`} value="todas" sx={{ fontWeight: 700, textTransform: "none" }} />
              <Tab label={`En Revisión (${stats.revision})`} value="revision" sx={{ fontWeight: 700, textTransform: "none", color: "#7e22ce" }} />
              <Tab label={`Doc. Solicitados (${stats.solicitados})`} value="solicitados" sx={{ fontWeight: 700, textTransform: "none", color: "#0284c7" }} />
              <Tab label={`Aprobados (${stats.aprobados})`} value="aprobados" sx={{ fontWeight: 700, textTransform: "none", color: "#16a34a" }} />
              <Tab label={`Desembolsados (${stats.desembolsados})`} value="desembolsados" sx={{ fontWeight: 700, textTransform: "none" }} />
            </Tabs>

            <TextField
              size="small"
              placeholder="Buscar por cliente, cédula o radicado..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: <SearchIcon sx={{ color: "text.secondary", mr: 1, fontSize: 18 }} />,
              }}
              sx={{ minWidth: 280 }}
            />
          </Stack>
        </Box>

        {loading ? (
          <Box display="flex" justifyContent="center" py={8}><CircularProgress /></Box>
        ) : filteredCases.length === 0 ? (
          <Box textAlign="center" py={8} color="text.secondary">
            <FilePresentIcon sx={{ fontSize: 60, opacity: 0.2, mb: 1 }} />
            <Typography variant="body1" fontWeight={700}>
              No se encontraron expedientes de crédito
            </Typography>
            <Typography variant="body2">
              Haz clic en "Nuevo Crédito / Estudio" para dar de alta el primer caso.
            </Typography>
          </Box>
        ) : (
          <TableContainer sx={{ maxHeight: 680 }}>
            <Table stickyHeader sx={{ minWidth: 980 }}>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 800, bgcolor: "#f8fafc", color: "#475569", fontSize: "0.75rem", textTransform: "uppercase", letterSpacing: 0.5 }}>
                    Radicado
                  </TableCell>
                  <TableCell sx={{ fontWeight: 800, bgcolor: "#f8fafc", color: "#475569", fontSize: "0.75rem", textTransform: "uppercase", letterSpacing: 0.5 }}>
                    Cliente & Contacto
                  </TableCell>
                  <TableCell sx={{ fontWeight: 800, bgcolor: "#f8fafc", color: "#475569", fontSize: "0.75rem", textTransform: "uppercase", letterSpacing: 0.5 }}>
                    Monto & Plazo
                  </TableCell>
                  <TableCell sx={{ fontWeight: 800, bgcolor: "#f8fafc", color: "#475569", fontSize: "0.75rem", textTransform: "uppercase", letterSpacing: 0.5 }}>
                    Fase 1: Estudio ($250k)
                  </TableCell>
                  <TableCell sx={{ fontWeight: 800, bgcolor: "#f8fafc", color: "#475569", fontSize: "0.75rem", textTransform: "uppercase", letterSpacing: 0.5 }}>
                    Contrato
                  </TableCell>
                  <TableCell sx={{ fontWeight: 800, bgcolor: "#f8fafc", color: "#475569", fontSize: "0.75rem", textTransform: "uppercase", letterSpacing: 0.5 }}>
                    Documentos
                  </TableCell>
                  <TableCell sx={{ fontWeight: 800, bgcolor: "#f8fafc", color: "#475569", fontSize: "0.75rem", textTransform: "uppercase", letterSpacing: 0.5 }}>
                    Estado del Caso
                  </TableCell>
                  <TableCell sx={{ fontWeight: 800, bgcolor: "#f8fafc", color: "#475569", fontSize: "0.75rem", textTransform: "uppercase", letterSpacing: 0.5 }} align="center">
                    Acciones
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredCases.map((c) => {
                  const totalReq = c.documents?.filter((d) => d.required).length || 0;
                  const uploadedReq = c.documents?.filter((d) => d.required && (d.fileUrl || d.status === "en_revision" || d.status === "aprobado")).length || 0;
                  const pctDocs = totalReq > 0 ? Math.round((uploadedReq / totalReq) * 100) : 0;
                  const studyStatus = c.studyPayment?.status || (c.studyPayment?.fileUrl ? "en_revision" : "pendiente");

                  return (
                    <TableRow
                      key={c.id}
                      hover
                      sx={{
                        "&:hover": { bgcolor: "#f8fafc" },
                        transition: "background-color 0.15s ease",
                      }}
                    >
                      {/* Radicado */}
                      <TableCell sx={{ py: 2 }}>
                        <Typography variant="body2" fontWeight={800} color="primary" fontFamily="monospace" sx={{ letterSpacing: 0.5 }}>
                          {c.code}
                        </Typography>
                        <Typography variant="caption" color="text.secondary" display="block">
                          {c.createdAt?.toDate ? c.createdAt.toDate().toLocaleDateString("es-CO") : "Reciente"}
                        </Typography>
                      </TableCell>

                      {/* Cliente */}
                      <TableCell sx={{ py: 2 }}>
                        <Stack direction="row" alignItems="center" spacing={1.5}>
                          <Avatar sx={{ width: 34, height: 34, bgcolor: "#0f172a", fontSize: "0.8rem", fontWeight: 800 }}>
                            {(c.clientName || c.email || "C").substring(0, 2).toUpperCase()}
                          </Avatar>
                          <Box sx={{ minWidth: 0 }}>
                            <Typography variant="body2" fontWeight={800} color="text.primary" noWrap sx={{ maxWidth: 180 }}>
                              {c.clientName || "Cliente"}
                            </Typography>
                            <Stack direction="row" alignItems="center" spacing={0.5} mt={0.3}>
                              <Chip
                                label={`${c.documentType || "CC"} ${c.documentNumber || "Sin cédula"}`}
                                size="small"
                                sx={{ height: 18, fontSize: "0.65rem", fontWeight: 700, bgcolor: "#f1f5f9" }}
                              />
                            </Stack>
                            <Typography variant="caption" color="text.secondary" display="block" noWrap sx={{ maxWidth: 180, mt: 0.3 }}>
                              ✉️ {c.email}
                            </Typography>
                          </Box>
                        </Stack>
                      </TableCell>

                      {/* Monto & Plazo */}
                      <TableCell sx={{ py: 2 }}>
                        <Typography variant="body2" fontWeight={900} color="text.primary">
                          ${(c.amount || 0).toLocaleString("es-CO")} COP
                        </Typography>
                        <Stack direction="row" spacing={0.5} mt={0.5} alignItems="center">
                          <Chip
                            label={c.creditType?.replace("_", " ").toUpperCase() || "LIBRE INVERSIÓN"}
                            size="small"
                            sx={{ height: 18, fontSize: "0.65rem", fontWeight: 800, bgcolor: "#e0f2fe", color: "#0369a1" }}
                          />
                          <Typography variant="caption" color="text.secondary" fontWeight={600}>
                            {c.termMonths || 12}m
                          </Typography>
                        </Stack>
                      </TableCell>

                      {/* Fase 1: Estudio ($250k) */}
                      <TableCell sx={{ py: 2 }}>
                        <Chip
                          label={
                            studyStatus === "verificado"
                              ? "✓ $250k Pagado"
                              : studyStatus === "en_revision" || c.studyPayment?.fileUrl
                              ? "📎 En Revisión"
                              : studyStatus === "rechazado"
                              ? "✕ Rechazado"
                              : "⏳ Pendiente"
                          }
                          size="small"
                          color={
                            studyStatus === "verificado"
                              ? "success"
                              : studyStatus === "en_revision" || c.studyPayment?.fileUrl
                              ? "info"
                              : studyStatus === "rechazado"
                              ? "error"
                              : "warning"
                          }
                          sx={{ fontWeight: 800, fontSize: "0.7rem", height: 22 }}
                        />
                        {c.studyPayment?.fileUrl && (
                          <Typography
                            variant="caption"
                            component="a"
                            href={c.studyPayment.fileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{ display: "block", color: "#2563eb", fontWeight: 700, mt: 0.5, fontSize: "0.68rem", textDecoration: "none", "&:hover": { textDecoration: "underline" } }}
                          >
                            Ver comprobante ↗
                          </Typography>
                        )}
                      </TableCell>

                      {/* Contrato de Prestación de Servicios */}
                      <TableCell sx={{ py: 2 }}>
                        {c.contract?.signed ? (
                          <Box>
                            <Chip
                              icon={<CheckCircleIcon sx={{ fontSize: "13px !important" }} />}
                              label="✓ Firmado"
                              size="small"
                              onClick={() => handleOpenContractModal(c)}
                              sx={{
                                fontWeight: 800,
                                fontSize: "0.68rem",
                                height: 22,
                                cursor: "pointer",
                                bgcolor: "#ecfdf5",
                                color: "#065f46",
                                border: "1px solid #a7f3d0",
                                "&:hover": { bgcolor: "#d1fae5" },
                              }}
                            />
                            <Typography
                              variant="caption"
                              onClick={() => handleOpenContractModal(c)}
                              sx={{
                                display: "block",
                                color: "#059669",
                                fontWeight: 700,
                                mt: 0.5,
                                fontSize: "0.68rem",
                                cursor: "pointer",
                                "&:hover": { textDecoration: "underline" },
                              }}
                            >
                              Ver Contrato ↗
                            </Typography>
                          </Box>
                        ) : (
                          <Chip
                            label="⏳ Sin Firmar"
                            size="small"
                            onClick={() => handleOpenContractModal(c)}
                            sx={{
                              fontWeight: 700,
                              fontSize: "0.68rem",
                              height: 22,
                              cursor: "pointer",
                              color: "#94a3b8",
                              bgcolor: "#f8fafc",
                              border: "1px dashed #cbd5e1",
                              "&:hover": { bgcolor: "#f1f5f9", color: "#64748b" },
                            }}
                          />
                        )}
                      </TableCell>

                      {/* Avance Documentos */}
                      <TableCell sx={{ py: 2 }}>
                        <Stack spacing={0.5} sx={{ minWidth: 120 }}>
                          <Stack direction="row" justifyContent="space-between" alignItems="center">
                            <Typography variant="caption" fontWeight={800} color={pctDocs === 100 ? "success.main" : "text.secondary"}>
                              {uploadedReq} de {totalReq} listos
                            </Typography>
                            <Typography variant="caption" fontWeight={800} color="text.secondary">
                              {pctDocs}%
                            </Typography>
                          </Stack>
                          <Box sx={{ width: "100%", bgcolor: "#e2e8f0", borderRadius: 1, height: 6, overflow: "hidden" }}>
                            <Box
                              sx={{
                                width: `${pctDocs}%`,
                                bgcolor: pctDocs === 100 ? "#10b981" : "#0284c7",
                                height: "100%",
                                borderRadius: 1,
                                transition: "width 0.3s ease",
                              }}
                            />
                          </Box>
                        </Stack>
                      </TableCell>

                      {/* Estado General */}
                      <TableCell sx={{ py: 2 }}>
                        <Chip
                          label={statusLabels[c.status] || c.status}
                          color={statusColors[c.status] || "default"}
                          size="small"
                          sx={{ fontWeight: 800, fontSize: "0.72rem" }}
                        />
                      </TableCell>

                      {/* Acciones */}
                      <TableCell align="center" sx={{ py: 2 }}>
                        <Stack direction="row" spacing={0.8} justifyContent="center" alignItems="center">
                          {/* Quick Start Review Button when 100% docs */}
                          {pctDocs === 100 && (c.status === "documentos_solicitados" || c.status === "estudio_inicial") && (
                            <Tooltip title="¡100% Documentos Listos! Haz clic para iniciar el proceso de revisión">
                              <Button
                                size="small"
                                variant="contained"
                                color="success"
                                startIcon={<TaskAltIcon sx={{ fontSize: 14 }} />}
                                onClick={() => handleQuickStartReview(c)}
                                sx={{
                                  textTransform: "none",
                                  fontWeight: 800,
                                  borderRadius: 2,
                                  px: 1.5,
                                  py: 0.5,
                                  fontSize: "0.72rem",
                                  bgcolor: "#059669",
                                  color: "#ffffff",
                                  whiteSpace: "nowrap",
                                  boxShadow: "0 2px 8px rgba(5, 150, 105, 0.3)",
                                  "&:hover": { bgcolor: "#047857" },
                                }}
                              >
                                Empezar Revisión
                              </Button>
                            </Tooltip>
                          )}

                          <Tooltip title="Gestionar Expediente, Validar Pagos y Documentos">
                            <Button
                              size="small"
                              variant="contained"
                              startIcon={<VisibilityIcon sx={{ fontSize: 16 }} />}
                              onClick={() => {
                                setSelectedCase(c);
                                setOpenDetailDialog(true);
                              }}
                              sx={{
                                textTransform: "none",
                                fontWeight: 800,
                                borderRadius: 2,
                                px: 1.5,
                                py: 0.5,
                                fontSize: "0.75rem",
                                bgcolor: "#0f172a",
                                "&:hover": { bgcolor: "#1e293b" },
                              }}
                            >
                              Ver Docs
                            </Button>
                          </Tooltip>

                          <Tooltip title="Escanear soportes con IA y autocompletar expediente">
                            <Button
                              size="small"
                              variant="outlined"
                              disabled={scanningCaseId === c.id}
                              startIcon={scanningCaseId === c.id ? <CircularProgress size={12} color="inherit" /> : <AutoAwesomeIcon sx={{ fontSize: 15 }} />}
                              onClick={() => handleScanAndAutofillCaseWithAI(c)}
                              sx={{
                                textTransform: "none",
                                fontWeight: 800,
                                borderRadius: 2,
                                px: 1.2,
                                py: 0.5,
                                fontSize: "0.72rem",
                                borderColor: "#c084fc",
                                color: "#7e22ce",
                                "&:hover": { bgcolor: "#f3e8ff", borderColor: "#a855f7" },
                              }}
                            >
                              {scanningCaseId === c.id ? "..." : "IA"}
                            </Button>
                          </Tooltip>

                          <Tooltip title="Contactar por WhatsApp">
                            <IconButton
                              size="small"
                              sx={{ color: "#25D366", bgcolor: "#f0fdf4", "&:hover": { bgcolor: "#dcfce7" } }}
                              onClick={() => openWhatsApp(c)}
                            >
                              <WhatsAppIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>

                          <Tooltip title="Eliminar Expediente">
                            <IconButton
                              size="small"
                              sx={{ color: "#94a3b8", "&:hover": { color: "#ef4444", bgcolor: "#fee2e2" } }}
                              onClick={() => handleDeleteCase(c.id!)}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Stack>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Card>

      {/* ================= DIALOG: CREAR CLIENTE & CRÉDITO ================= */}
      <Dialog
        open={openCreateDialog}
        onClose={() => !creating && setOpenCreateDialog(false)}
        fullWidth
        maxWidth="md"
        PaperProps={{ sx: { borderRadius: 3 } }}
      >
        <DialogTitle sx={{ fontWeight: 800, pb: 1 }}>
          ✨ Crear Estudio de Crédito & Asignar a Cliente
        </DialogTitle>
        <Typography variant="body2" color="text.secondary" px={3}>
          Selecciona un cliente que ya haya iniciado sesión o se haya registrado en la app. Si faltan su cédula o teléfono, agrégalos aquí y se guardarán automáticamente en su perfil.
        </Typography>
        <Divider sx={{ my: 1.5 }} />

        <DialogContent>
          <Stack spacing={3}>
            {/* 1. Selección del Cliente Registrado */}
            <Box>
              <Typography variant="subtitle2" fontWeight={800} color="primary" mb={1.5}>
                1. SELECCIONA EL CLIENTE REGISTRADO EN EL PORTAL / APP
              </Typography>
              <Autocomplete
                options={portalUsers}
                getOptionLabel={(option) =>
                  `${option.displayName || option.email} (${option.documentNumber ? option.documentType + " " + option.documentNumber + " - " : ""}${option.email})`
                }
                value={selectedExistingUser}
                onChange={(_, newValue) => handleSelectUser(newValue)}
                noOptionsText="No se encontraron usuarios registrados en la app."
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Buscar cliente por Nombre, Cédula o Correo *"
                    placeholder="Escribe para buscar..."
                    size="small"
                    helperText="Los usuarios deben iniciar sesión o registrarse en la app para poder asignarles el crédito."
                  />
                )}
              />

              {selectedExistingUser && (
                <Box mt={2}>
                  {/* Tarjeta de Resumen del Cliente */}
                  <Card variant="outlined" sx={{ p: 2, bgcolor: "#f8fafc", borderColor: "#e2e8f0", borderRadius: 2.5 }}>
                    <Stack direction={{ xs: "column", sm: "row" }} alignItems={{ sm: "center" }} gap={2}>
                      <Avatar sx={{ bgcolor: "#0f172a", fontWeight: 800, width: 44, height: 44 }}>
                        {(selectedExistingUser.displayName || selectedExistingUser.email || "U").substring(0, 2).toUpperCase()}
                      </Avatar>
                      <Box sx={{ flex: 1 }}>
                        <Stack direction="row" alignItems="center" gap={1}>
                          <Typography variant="subtitle2" fontWeight={800} color="text.primary">
                            {selectedExistingUser.displayName || "Usuario Registrado"}
                          </Typography>
                          <Chip label="Cliente Activo" size="small" color="success" sx={{ height: 20, fontSize: "0.65rem", fontWeight: 800 }} />
                        </Stack>
                        <Typography variant="caption" color="text.secondary" display="block">
                          📧 {selectedExistingUser.email}
                        </Typography>
                      </Box>
                    </Stack>
                  </Card>

                  {/* Advertencia si no tiene cédula o teléfono */}
                  {isMissingData && (
                    <Alert severity="warning" sx={{ mt: 2, borderRadius: 2, fontWeight: 600 }}>
                      ⚠️ <strong>Datos de contacto incompletos:</strong> El cliente aún no ha registrado su Cédula y/o Teléfono. Por favor complétalos a continuación; se sincronizarán de inmediato en su perfil del portal.
                    </Alert>
                  )}

                  {/* Campos de Identificación del Cliente (siempre editables para corregir o agregar) */}
                  <Box sx={{ mt: 2, p: 2, bgcolor: isMissingData ? "#fffbeb" : "#f8fafc", border: isMissingData ? "1px solid #fde68a" : "1px solid #e2e8f0", borderRadius: 2.5 }}>
                    <Typography variant="caption" color="text.secondary" fontWeight={800} textTransform="uppercase" letterSpacing={0.5} display="block" mb={1.5}>
                      {isMissingData ? "Completar Datos del Usuario (Se guardarán en su cuenta)" : "Datos de Identificación del Cliente"}
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField
                          label="Nombre Completo del Cliente *"
                          fullWidth
                          size="small"
                          value={clientFullName}
                          onChange={(e) => setClientFullName(e.target.value)}
                        />
                      </Grid>
                      <Grid size={{ xs: 5, sm: 2 }}>
                        <FormControl fullWidth size="small">
                          <InputLabel>Tipo Doc.</InputLabel>
                          <Select
                            value={clientDocType}
                            label="Tipo Doc."
                            onChange={(e) => setClientDocType(e.target.value)}
                          >
                            <MenuItem value="CC">C.C.</MenuItem>
                            <MenuItem value="CE">C.E.</MenuItem>
                            <MenuItem value="NIT">NIT</MenuItem>
                            <MenuItem value="PASAPORTE">Pasaporte</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid size={{ xs: 7, sm: 4 }}>
                        <TextField
                          label="Número de Documento / Cédula *"
                          fullWidth
                          size="small"
                          value={clientDocNumber}
                          onChange={(e) => setClientDocNumber(e.target.value)}
                          placeholder="Ej. 1020304050"
                          error={!clientDocNumber.trim()}
                          helperText={!clientDocNumber.trim() ? "Obligatorio para el estudio" : ""}
                        />
                      </Grid>
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField
                          label="Teléfono / WhatsApp *"
                          fullWidth
                          size="small"
                          value={clientPhone}
                          onChange={(e) => setClientPhone(e.target.value)}
                          placeholder="Ej. 300 123 4567"
                          error={!clientPhone.trim()}
                          helperText={!clientPhone.trim() ? "Obligatorio para contacto" : ""}
                        />
                      </Grid>
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField
                          label="Correo Registrado (Solo Lectura)"
                          fullWidth
                          size="small"
                          value={selectedExistingUser.email}
                          disabled
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              )}
            </Box>

            <Divider />

            {/* 2. Condiciones Financieras del Estudio */}
            <Box>
              <Typography variant="subtitle2" fontWeight={800} color="primary" mb={1.5}>
                2. CONDICIONES FINANCIERAS & MONTO APROXIMADO SOLICITADO
              </Typography>
              <Grid container spacing={2}>
                <Grid size={{ xs: 12, sm: 5 }}>
                  <TextField
                    label="Monto Aproximado que Necesita el Cliente ($ COP) *"
                    type="number"
                    fullWidth
                    size="small"
                    value={newClient.amount}
                    onChange={(e) => setNewClient((p) => ({ ...p, amount: Number(e.target.value) }))}
                    helperText="Monto aproximado para el estudio financiero"
                  />
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Línea de Crédito</InputLabel>
                    <Select
                      value={newClient.creditType}
                      label="Línea de Crédito"
                      onChange={(e) => setNewClient((p) => ({ ...p, creditType: e.target.value }))}
                    >
                      <MenuItem value="libre_inversion">Libre Inversión</MenuItem>
                      <MenuItem value="personal">Crédito Personal</MenuItem>
                      <MenuItem value="negocio">Empresarial / Pymes</MenuItem>
                      <MenuItem value="microcredito">Microcrédito</MenuItem>
                      <MenuItem value="vehiculo">Vehículo</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid size={{ xs: 12, sm: 3 }}>
                  <TextField
                    label="Plazo Estimado (Meses) *"
                    type="number"
                    fullWidth
                    size="small"
                    value={newClient.termMonths}
                    onChange={(e) => setNewClient((p) => ({ ...p, termMonths: Number(e.target.value) }))}
                  />
                </Grid>
              </Grid>
            </Box>

            <Divider />

            {/* 3. Selección de Documentos según Perfil Económico */}
            <Box>
              <Typography variant="subtitle2" fontWeight={800} color="primary" mb={1.5}>
                3. PERFIL ECONÓMICO Y DOCUMENTOS EXIGIDOS PARA EL ESTUDIO
              </Typography>

              {/* Selector directo de Actividad Económica */}
              <Card variant="outlined" sx={{ p: 2, mb: 2.5, bgcolor: "#f0f9ff", borderColor: "#bae6fd", borderRadius: 2.5 }}>
                <Grid container spacing={2} alignItems="center">
                  <Grid size={{ xs: 12, md: 7 }}>
                    <FormControl fullWidth size="small">
                      <InputLabel sx={{ fontWeight: 800, color: "#0369a1" }}>
                        Actividad Económica del Cliente *
                      </InputLabel>
                      <Select
                        value={newClient.economicActivity || "asalariado_empleado"}
                        label="Actividad Económica del Cliente *"
                        onChange={(e) => handleEconomicActivityChange(e.target.value)}
                        sx={{ fontWeight: 800, bgcolor: "#ffffff" }}
                      >
                        {economicProfiles.map((p) => (
                          <MenuItem key={p.id} value={p.id}>
                            {p.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid size={{ xs: 12, md: 5 }}>
                    <Chip
                      icon={<AutoAwesomeIcon fontSize="small" sx={{ color: "#0284c7 !important" }} />}
                      label={`Matriz General: ${newClient.selectedDocs.length} Docs Seleccionados`}
                      color="info"
                      variant="filled"
                      sx={{ fontWeight: 800, width: "100%", py: 2.2, borderRadius: 2 }}
                    />
                  </Grid>
                </Grid>
                <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1.5, fontWeight: 500 }}>
                  💡 <strong>Selecciona la Actividad Económica</strong> para marcar automáticamente los documentos exigidos por la <strong>Matriz General</strong> para este perfil.
                </Typography>
              </Card>

              {(() => {
                const combinedList = [
                  ...PRESET_TEMPLATES,
                  ...customDocTypes
                    .filter((c) => !PRESET_TEMPLATES.some((p) => isDocMatched(p.id, c.id)))
                    .map((c) => ({
                      id: c.id,
                      title: c.label,
                      description: c.description || "Documento configurado en la Matriz General",
                      required: true,
                    })),
                ];

                return (
                  <Grid container spacing={1.5}>
                    {combinedList.map((tmpl) => {
                      const isChecked = newClient.selectedDocs.includes(tmpl.id);
                      return (
                        <Grid size={{ xs: 12, sm: 6 }} key={tmpl.id}>
                          <Box
                            sx={{
                              p: 1.5,
                              borderRadius: 2,
                              border: isChecked ? "1.5px solid #2563eb" : "1px solid #e2e8f0",
                              bgcolor: isChecked ? "#eff6ff" : "#fff",
                              transition: "all 0.2s ease-in-out",
                            }}
                          >
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={isChecked}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setNewClient((p) => ({ ...p, selectedDocs: [...p.selectedDocs, tmpl.id] }));
                                    } else {
                                      setNewClient((p) => ({ ...p, selectedDocs: p.selectedDocs.filter((id) => id !== tmpl.id) }));
                                    }
                                  }}
                                  color="primary"
                                />
                              }
                              label={
                                <Box>
                                  <Typography variant="body2" fontWeight={700}>
                                    {tmpl.title} {tmpl.required && <span style={{ color: "#ef4444" }}>*</span>}
                                  </Typography>
                                  <Typography variant="caption" color="text.secondary">
                                    {tmpl.description}
                                  </Typography>
                                </Box>
                              }
                            />
                          </Box>
                        </Grid>
                      );
                    })}
                  </Grid>
                );
              })()}
            </Box>
          </Stack>
        </DialogContent>

        <DialogActions sx={{ p: 3, pt: 1 }}>
          <Button onClick={() => setOpenCreateDialog(false)} disabled={creating} color="inherit">
            Cancelar
          </Button>
          <Button
            variant="contained"
            onClick={handleCreateClientAndCase}
            disabled={creating || !selectedExistingUser}
            startIcon={creating ? <CircularProgress size={16} /> : undefined}
            sx={{ borderRadius: 2, px: 4, fontWeight: 800 }}
          >
            {creating ? "Creando Estudio..." : "✨ Iniciar Estudio & Asignar Crédito"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ================= DIALOG: GESTIÓN DE EXPEDIENTE & DOCUMENTOS ================= */}
      <Dialog
        open={openDetailDialog}
        onClose={() => setOpenDetailDialog(false)}
        fullWidth
        maxWidth="md"
        PaperProps={{ sx: { borderRadius: 3 } }}
      >
        {selectedCase && (
          <>
            <DialogTitle sx={{ fontWeight: 800, pb: 1, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Box>
                <Typography variant="h6" fontWeight={800}>
                  Expediente de Crédito - {selectedCase.code}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Cliente: {selectedCase.clientName} ({selectedCase.documentType} {selectedCase.documentNumber}) | 📞 {selectedCase.phone}
                </Typography>
              </Box>
              <Chip
                label={statusLabels[selectedCase.status]}
                color={statusColors[selectedCase.status]}
                sx={{ fontWeight: 800 }}
              />
            </DialogTitle>
            <Divider />

            <DialogContent>
              <Stack spacing={3}>
                {/* 1. Cambio de Estado General */}
                <Box sx={{ p: 2.5, bgcolor: "#f8fafc", borderRadius: 2.5, border: "1px solid #e2e8f0" }}>
                  <Typography variant="subtitle2" fontWeight={800} mb={2}>
                    ⚙️ CAMBIAR ESTADO GENERAL DEL CRÉDITO
                  </Typography>
                  <Grid container spacing={2} alignItems="center">
                    <Grid size={{ xs: 12, sm: 5 }}>
                      <FormControl fullWidth size="small">
                        <InputLabel>Estado del Crédito</InputLabel>
                        <Select
                          value={newCaseStatus}
                          label="Estado del Crédito"
                          onChange={(e) => setNewCaseStatus(e.target.value as any)}
                        >
                          <MenuItem value="estudio_inicial">🟡 Estudio Inicial</MenuItem>
                          <MenuItem value="documentos_solicitados">📄 Solicitud de Documentos</MenuItem>
                          <MenuItem value="en_revision">🔍 Documentos en Revisión</MenuItem>
                          <MenuItem value="aprobado">🟢 Crédito Aprobado</MenuItem>
                          <MenuItem value="en_desembolso">🏦 En Proceso de Desembolso</MenuItem>
                          <MenuItem value="desembolsado">💰 Desembolsado con Éxito</MenuItem>
                          <MenuItem value="rechazado">🔴 Crédito Rechazado</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid size={{ xs: 12, sm: 7 }}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Nota / Observación para el Cliente (Visible en su portal)"
                        value={newStatusNote}
                        onChange={(e) => setNewStatusNote(e.target.value)}
                        placeholder="Ej: Documentos aprobados. Procedemos con desembolso."
                      />
                    </Grid>
                  </Grid>

                  <Box display="flex" justifyContent="flex-end" mt={2}>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleUpdateCaseStatus}
                      sx={{ borderRadius: 2, fontWeight: 700 }}
                    >
                      Guardar Nuevo Estado
                    </Button>
                  </Box>
                </Box>

                {/* FASE 1: Comprobante del Estudio Financiero ($250.000 COP) */}
                <Card sx={{ p: 2.5, borderRadius: 2.5, border: "1px solid #e2e8f0", bgcolor: "#f8fafc" }}>
                  <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems={{ sm: "center" }} gap={2}>
                    <Box>
                      <Stack direction="row" alignItems="center" gap={1}>
                        <Typography variant="subtitle2" fontWeight={800}>
                          💳 FASE 1: PAGO DEL ESTUDIO FINANCIERO ($250.000 COP)
                        </Typography>
                        <Chip
                          label={
                            selectedCase.studyPayment?.status === "verificado"
                              ? "PAGO VERIFICADO"
                              : selectedCase.studyPayment?.status === "en_revision"
                              ? "COMPROBANTE EN REVISIÓN"
                              : selectedCase.studyPayment?.status === "rechazado"
                              ? "RECHAZADO"
                              : "PENDIENTE DE PAGO"
                          }
                          size="small"
                          color={
                            selectedCase.studyPayment?.status === "verificado"
                              ? "success"
                              : selectedCase.studyPayment?.status === "en_revision"
                              ? "info"
                              : selectedCase.studyPayment?.status === "rechazado"
                              ? "error"
                              : "warning"
                          }
                          sx={{ fontWeight: 800, fontSize: "10px" }}
                        />
                      </Stack>
                      <Typography variant="caption" color="text.secondary" display="block" mt={0.5}>
                        Cuenta Bancaria: Bancolombia Cta Corriente # 29899994884 (NIT 901500993)
                      </Typography>
                      {selectedCase.studyPayment?.fileName && (
                        <Typography variant="caption" color="primary" display="block" fontWeight={600} mt={0.5}>
                          📎 Archivo adjuntado por el cliente: {selectedCase.studyPayment.fileName}
                        </Typography>
                      )}
                      {selectedCase.studyPayment?.rejectionReason && (
                        <Typography variant="caption" color="error" display="block" fontWeight={700} mt={0.5}>
                          Motivo rechazo: {selectedCase.studyPayment.rejectionReason}
                        </Typography>
                      )}
                    </Box>

                    <Stack direction="row" gap={1}>
                      {selectedCase.studyPayment?.fileUrl && (
                        <Button
                          size="small"
                          variant="outlined"
                          href={selectedCase.studyPayment.fileUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          sx={{ textTransform: "none", fontWeight: 700 }}
                        >
                          Ver Comprobante
                        </Button>
                      )}
                      {selectedCase.studyPayment?.status !== "verificado" && (
                        <Button
                          size="small"
                          variant="contained"
                          color="success"
                          onClick={() => handleVerifyStudyPayment(selectedCase)}
                          sx={{ textTransform: "none", fontWeight: 700 }}
                        >
                          ✓ Validar Pago ($250k)
                        </Button>
                      )}
                      {selectedCase.studyPayment?.fileUrl && selectedCase.studyPayment?.status !== "rechazado" && (
                        <Button
                          size="small"
                          variant="outlined"
                          color="error"
                          onClick={() => handleRejectStudyPayment(selectedCase)}
                          sx={{ textTransform: "none", fontWeight: 700 }}
                        >
                          Rechazar
                        </Button>
                      )}
                    </Stack>
                  </Stack>
                </Card>

                {/* CONTRATO DE PRESTACIÓN DE SERVICIOS & COMISIÓN (8%) */}
                <Card sx={{ p: 2.5, borderRadius: 2.5, border: "1px solid #e2e8f0", bgcolor: "#f8fafc" }}>
                  <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems={{ sm: "center" }} gap={2}>
                    <Box>
                      <Stack direction="row" alignItems="center" gap={1}>
                        <Typography variant="subtitle2" fontWeight={800}>
                          📑 CONTRATO DE PRESTACIÓN DE SERVICIOS & COMISIÓN
                        </Typography>
                        <Chip
                          label={selectedCase.contract?.signed ? "✓ CONTRATO FIRMADO" : "PENDIENTE DE FIRMA"}
                          size="small"
                          color={selectedCase.contract?.signed ? "success" : "warning"}
                          sx={{ fontWeight: 800, fontSize: "10px" }}
                        />
                      </Stack>
                      <Typography variant="caption" color="text.secondary" display="block" mt={0.5}>
                        {selectedCase.contract?.signed
                          ? `Firmado digitalmente el ${selectedCase.contract.signedDateDay || "__"} de ${selectedCase.contract.signedDateMonth || "___"} de ${selectedCase.contract.signedDateYear || "2026"} por ${selectedCase.contract.repLegalName || selectedCase.clientName} (CC ${selectedCase.contract.repLegalDoc || selectedCase.documentNumber})`
                          : "El cliente debe formalizar la firma electrónica del contrato a través de su portal web."}
                      </Typography>
                      {selectedCase.contract?.companyName && selectedCase.contract?.companyName !== "N/A" && (
                        <Typography variant="caption" color="primary" display="block" fontWeight={600} mt={0.5}>
                          🏢 Razón Social: {selectedCase.contract.companyName} (NIT: {selectedCase.contract.companyNit})
                        </Typography>
                      )}
                    </Box>

                    <Stack direction="row" gap={1.5} alignItems="center">
                      {selectedCase.contract?.signed && selectedCase.contract?.signatureDataUrl && (
                        <Box
                          sx={{
                            display: { xs: "none", sm: "flex" },
                            alignItems: "center",
                            justifyContent: "center",
                            p: 0.5,
                            bgcolor: "#ffffff",
                            border: "1px solid #cbd5e1",
                            borderRadius: 1.5,
                            height: 42,
                            width: 100,
                            overflow: "hidden",
                          }}
                        >
                          <img
                            src={selectedCase.contract.signatureDataUrl}
                            alt="Firma"
                            style={{ maxHeight: "100%", maxWidth: "100%", objectFit: "contain" }}
                          />
                        </Box>
                      )}
                      <Button
                        size="small"
                        variant="contained"
                        color={selectedCase.contract?.signed ? "primary" : "inherit"}
                        startIcon={<HistoryEduIcon />}
                        onClick={() => handleOpenContractModal(selectedCase)}
                        sx={{ textTransform: "none", fontWeight: 700, borderRadius: 2 }}
                      >
                        {selectedCase.contract?.signed ? "Ver Contrato Firmado" : "Ver Borrador"}
                      </Button>
                    </Stack>
                  </Stack>
                </Card>

                {/* 2. Lista de Documentos y Auditoría */}
                <Box>
                  <Typography variant="subtitle2" fontWeight={800} mb={1}>
                    📁 AUDITORÍA DE DOCUMENTOS SOLICITADOS
                  </Typography>
                  <Typography variant="caption" color="text.secondary" display="block" mb={2}>
                    Revisa los soportes subidos por el cliente en Firebase Storage. Puedes aprobarlos individualmente o aceptarlos todos para avanzar a la fase de revisión.
                  </Typography>

                  {/* Banner de Aceptación Masiva y Avance a "En Revisión" */}
                  {selectedCase.documents && selectedCase.documents.length > 0 && (
                    <Card
                      sx={{
                        p: 2,
                        mb: 2.5,
                        borderRadius: 2.5,
                        border: "1.5px solid",
                        borderColor: selectedCase.documents.some((d) => !!d.fileUrl) ? "#10b981" : "#e2e8f0",
                        bgcolor: selectedCase.status === "en_revision" ? "#faf5ff" : selectedCase.documents.some((d) => !!d.fileUrl) ? "#ecfdf5" : "#f8fafc",
                      }}
                    >
                      <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems={{ sm: "center" }} gap={2}>
                        <Box>
                          <Stack direction="row" alignItems="center" gap={1}>
                            <TaskAltIcon sx={{ color: selectedCase.documents.some((d) => !!d.fileUrl) ? "#10b981" : "#94a3b8", fontSize: 24 }} />
                            <Typography variant="subtitle2" fontWeight={800} color={selectedCase.documents.some((d) => !!d.fileUrl) ? "#065f46" : "text.primary"}>
                              {selectedCase.documents.every((d) => !!d.fileUrl)
                                ? "¡Todos los Documentos Cargados con Éxito!"
                                : "Aceptar Documentos & Iniciar Revisión"}
                            </Typography>
                            {selectedCase.status === "en_revision" && (
                              <Chip label="CASO EN REVISIÓN" size="small" color="secondary" sx={{ fontWeight: 800, fontSize: "10px" }} />
                            )}
                          </Stack>
                          <Typography variant="caption" color="text.secondary" display="block" mt={0.5}>
                            {selectedCase.documents.filter((d) => !!d.fileUrl).length} de {selectedCase.documents.length} documentos cargados por el cliente.
                            {selectedCase.documents.every((d) => !!d.fileUrl)
                              ? " ¡El expediente cuenta con el 100% de los documentos! Presiona el botón para dar inicio formal a la fase de revisión y auditoría financiera."
                              : " Puedes aceptar los documentos adjuntados hasta la fecha y avanzar el expediente a 'En Revisión'."}
                          </Typography>
                        </Box>

                        <Button
                          variant="contained"
                          color="success"
                          startIcon={<TaskAltIcon />}
                          onClick={handleAcceptAllAndMoveToReview}
                          disabled={!selectedCase.documents.some((d) => !!d.fileUrl)}
                          sx={{
                            fontWeight: 800,
                            textTransform: "none",
                            borderRadius: 2,
                            px: 3,
                            py: 1.2,
                            fontSize: "0.82rem",
                            whiteSpace: "nowrap",
                            bgcolor: "#059669",
                            boxShadow: "0 4px 12px rgba(16, 185, 129, 0.35)",
                            "&:hover": { bgcolor: "#047857" },
                          }}
                        >
                          {selectedCase.documents.every((d) => !!d.fileUrl)
                            ? "🚀 Empezar Proceso de Revisión"
                            : "✓ Aceptar Documentos y Empezar Revisión"}
                        </Button>
                      </Stack>
                    </Card>
                  )}

                  <Stack spacing={2}>
                    {selectedCase.documents.map((d) => (
                      <Card key={d.id} sx={{ p: 2, borderRadius: 2, border: "1px solid #e2e8f0" }}>
                        <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems={{ sm: "center" }} gap={1.5}>
                          <Box>
                            <Stack direction="row" alignItems="center" gap={1}>
                              <Typography variant="subtitle2" fontWeight={800}>{d.title}</Typography>
                              <Chip
                                label={d.status?.toUpperCase()}
                                size="small"
                                color={
                                  d.status === "aprobado"
                                    ? "success"
                                    : d.status === "en_revision"
                                    ? "secondary"
                                    : d.status === "rechazado"
                                    ? "error"
                                    : "warning"
                                }
                                sx={{ fontSize: "10px", height: 20, fontWeight: 800 }}
                              />
                              {d.required && <Chip label="Obligatorio" size="small" variant="outlined" sx={{ fontSize: "10px", height: 20 }} />}
                            </Stack>
                            {d.description && (
                              <Typography variant="caption" color="text.secondary" display="block" mt={0.5}>
                                {d.description}
                              </Typography>
                            )}
                            {d.rejectionReason && (
                              <Typography variant="caption" color="error" display="block" fontWeight={700} mt={0.5}>
                                Motivo de rechazo actual: {d.rejectionReason}
                              </Typography>
                            )}
                          </Box>

                          {/* Actions / View link */}
                          <Stack direction="row" spacing={1} alignItems="center">
                            {d.fileUrl ? (
                              <Button
                                size="small"
                                variant="outlined"
                                startIcon={<OpenInNewIcon />}
                                onClick={() => openDocumentUrl(d.fileUrl, d.title || "documento.pdf")}
                                sx={{ textTransform: "none", fontWeight: 700, borderRadius: 2 }}
                              >
                                Ver Archivo
                              </Button>
                            ) : (
                              <Typography variant="caption" color="text.secondary" sx={{ fontStyle: "italic" }}>
                                ⏳ No subido aún
                              </Typography>
                            )}

                            {d.fileUrl && (
                              <>
                                <Button
                                  size="small"
                                  color="success"
                                  variant={d.status === "aprobado" ? "contained" : "outlined"}
                                  startIcon={<CheckCircleIcon />}
                                  onClick={() => handleApproveDocument(d.id)}
                                  sx={{ textTransform: "none", fontWeight: 700, borderRadius: 2 }}
                                >
                                  Aprobar
                                </Button>

                                <Button
                                  size="small"
                                  color="error"
                                  variant={d.status === "rechazado" ? "contained" : "outlined"}
                                  startIcon={<CancelIcon />}
                                  onClick={() => setShowRejectField((p) => ({ ...p, [d.id]: !p[d.id] }))}
                                  sx={{ textTransform: "none", fontWeight: 700, borderRadius: 2 }}
                                >
                                  Rechazar
                                </Button>
                              </>
                            )}
                          </Stack>
                        </Stack>

                        {/* Rejection input box */}
                        {showRejectField[d.id] && (
                          <Box sx={{ mt: 2, pt: 1.5, borderTop: "1px dashed #fecaca" }}>
                            <Stack direction="row" spacing={1}>
                              <TextField
                                size="small"
                                fullWidth
                                label="Motivo de rechazo (Se mostrará en el portal del cliente)"
                                placeholder="Ej: El archivo está borroso o incompleto."
                                value={rejectionInput[d.id] || ""}
                                onChange={(e) => setRejectionInput((p) => ({ ...p, [d.id]: e.target.value }))}
                              />
                              <Button
                                variant="contained"
                                color="error"
                                size="small"
                                onClick={() => handleRejectDocument(d.id)}
                                sx={{ fontWeight: 700, whiteSpace: "nowrap" }}
                              >
                                Confirmar Rechazo
                              </Button>
                            </Stack>
                          </Box>
                        )}
                      </Card>
                    ))}
                  </Stack>

                  {/* Botón al pie de la lista de documentos */}
                  {selectedCase.documents.some((d) => !!d.fileUrl) && (
                    <Box sx={{ mt: 2.5, display: "flex", justifyContent: "flex-end" }}>
                      <Button
                        variant="contained"
                        color="success"
                        startIcon={<TaskAltIcon />}
                        onClick={handleAcceptAllAndMoveToReview}
                        sx={{
                          fontWeight: 800,
                          borderRadius: 2,
                          textTransform: "none",
                          px: 3,
                          py: 1.2,
                          bgcolor: "#059669",
                          boxShadow: "0 4px 14px rgba(5, 150, 105, 0.3)",
                          "&:hover": { bgcolor: "#047857" },
                        }}
                      >
                        {selectedCase.documents.every((d) => !!d.fileUrl)
                          ? "🚀 Empezar Proceso de Revisión"
                          : "✓ Aceptar Documentos y Empezar Revisión"}
                      </Button>
                    </Box>
                  )}
                </Box>

                <Divider />

                {/* 3. Solicitar un Documento Adicional */}
                <Box sx={{ p: 2, bgcolor: "#f8fafc", borderRadius: 2, border: "1px dashed #cbd5e1" }}>
                  <Typography variant="subtitle2" fontWeight={800} mb={1.5}>
                    + SOLICITAR DOCUMENTO ADICIONAL AL CLIENTE
                  </Typography>
                  <Grid container spacing={1.5} alignItems="center">
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <TextField
                        size="small"
                        fullWidth
                        label="Nombre del documento *"
                        placeholder="Ej: Poder notarial o carta de ingresos adicionales"
                        value={customDocTitle}
                        onChange={(e) => setCustomDocTitle(e.target.value)}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                      <TextField
                        size="small"
                        fullWidth
                        label="Instrucción / Descripción"
                        placeholder="Ej: Documento firmado y autenticado"
                        value={customDocDesc}
                        onChange={(e) => setCustomDocDesc(e.target.value)}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 2 }}>
                      <Button
                        fullWidth
                        variant="outlined"
                        size="small"
                        onClick={handleAddCustomDocument}
                        sx={{ fontWeight: 700, height: 40 }}
                      >
                        Solicitar
                      </Button>
                    </Grid>
                  </Grid>
                </Box>

                <Divider />

                {/* 4. SELECCIÓN DE BANCO & GENERADOR DE FORMULARIO AUTOCOMPLETADO */}
                <Box sx={{ p: 2.5, bgcolor: "#f0f9ff", borderRadius: 2.5, border: "1.5px solid #0284c7" }}>
                  <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                    <Chip label="Cruce de Datos IA & Firestore" size="small" color="primary" sx={{ fontWeight: 800, fontSize: "0.7rem" }} />
                    <Typography variant="subtitle2" fontWeight={800} color="#0369a1">
                      🏦 AUTOCOMPLETAR FORMULARIO OFICIAL DE BANCO
                    </Typography>
                  </Stack>
                  <Typography variant="caption" color="text.secondary" display="block" mb={2}>
                    Selecciona el banco de destino. El sistema cruzará la información del cliente y sus soportes subidos en <strong>next-front</strong> para pre-llenar la solicitud oficial.
                  </Typography>

                  <Grid container spacing={2} alignItems="center">
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <FormControl fullWidth size="small">
                        <InputLabel sx={{ fontWeight: 700 }}>Banco de Destino *</InputLabel>
                        <Select
                          value={selectedTargetBankId || (banksList[0]?.id || "bbva")}
                          label="Banco de Destino *"
                          onChange={(e) => {
                            setSelectedTargetBankId(e.target.value);
                            const targetB = banksList.find((b) => b.id === e.target.value);
                            if (targetB && targetB.templates && targetB.templates.length > 0) {
                              setSelectedBankTemplateId(targetB.templates[0].id);
                            } else {
                              setSelectedBankTemplateId("");
                            }
                          }}
                          sx={{ borderRadius: 2, fontWeight: 700, bgcolor: "#fff" }}
                        >
                          {banksList.map((b) => (
                            <MenuItem key={b.id} value={b.id}>
                              {b.name} ({b.code})
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6 }}>
                      {(() => {
                        const targetBank = banksList.find((b) => b.id === (selectedTargetBankId || banksList[0]?.id)) || banksList[0];
                        const templates = targetBank?.templates || [];
                        const currentTplId = selectedBankTemplateId || templates[0]?.id || "";

                        return (
                          <FormControl fullWidth size="small">
                            <InputLabel sx={{ fontWeight: 700 }}>Formulario Oficial del Banco</InputLabel>
                            <Select
                              value={currentTplId}
                              label="Formulario Oficial del Banco"
                              onChange={(e) => setSelectedBankTemplateId(e.target.value)}
                              disabled={templates.length === 0}
                              sx={{ borderRadius: 2, fontWeight: 700, bgcolor: "#fff" }}
                            >
                              {templates.map((t: any) => (
                                <MenuItem key={t.id} value={t.id}>
                                  {t.title} ({t.fileName})
                                </MenuItem>
                              ))}
                              {templates.length === 0 && (
                                <MenuItem value="">Sin formularios adjuntos en este banco</MenuItem>
                              )}
                            </Select>
                          </FormControl>
                        );
                      })()}
                    </Grid>
                  </Grid>

                  <Box display="flex" justifyContent="flex-end" gap={1.5} mt={2}>
                    <Button
                      variant="outlined"
                      color="secondary"
                      disabled={scanningCaseId === selectedCase.id}
                      startIcon={scanningCaseId === selectedCase.id ? <CircularProgress size={16} color="inherit" /> : <AutoAwesomeIcon />}
                      onClick={() => handleScanAndAutofillCaseWithAI(selectedCase)}
                      sx={{ borderRadius: 2, fontWeight: 800, px: 2.5 }}
                    >
                      {scanningCaseId === selectedCase.id ? "Escaneando Soportes..." : "⚡ Escanear & Autocompletar Expediente con IA"}
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<AutoAwesomeIcon />}
                      onClick={() => setOpenAutofillDialog(true)}
                      sx={{ borderRadius: 2, fontWeight: 800, px: 3, background: "linear-gradient(135deg, #0284c7 0%, #2563eb 100%)" }}
                    >
                      ⚡ Generar Formulario Autocompletado con IA
                    </Button>
                    <Button
                      variant="contained"
                      startIcon={<DownloadIcon />}
                      onClick={() =>
                        fillAndDownloadBankPdf(
                          "/templates/promosumma_persona_natural.pdf",
                          selectedCase,
                          "Promosumma S.A.S.",
                          "promosumma_persona_natural.pdf",
                          "#0284c7"
                        )
                      }
                      sx={{
                        borderRadius: 2,
                        fontWeight: 800,
                        px: 3,
                        background: "linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)",
                        boxShadow: "0 4px 12px rgba(2, 132, 199, 0.35)",
                      }}
                    >
                      📄 Radicar Solicitud Promosumma (PDF Firmado)
                    </Button>
                  </Box>
                </Box>
              </Stack>
            </DialogContent>

            <DialogActions sx={{ p: 2.5, justifyContent: "space-between" }}>
              <Button
                startIcon={<WhatsAppIcon />}
                color="success"
                variant="outlined"
                onClick={() => openWhatsApp(selectedCase)}
                sx={{ borderRadius: 2 }}
              >
                Notificar por WhatsApp
              </Button>
              <Button onClick={() => setOpenDetailDialog(false)} color="inherit" sx={{ fontWeight: 700 }}>
                Cerrar
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>

      {/* ================= DIALOG: VISOR DE FORMULARIO AUTOCOMPLETADO BANCO ================= */}
      <Dialog
        open={openAutofillDialog}
        onClose={() => setOpenAutofillDialog(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{ sx: { borderRadius: 3 } }}
      >
        {selectedCase && (() => {
          const currentBank = banksList.find((b) => b.id === (selectedTargetBankId || banksList[0]?.id)) || banksList[0] || { name: "Banco Seleccionado", code: "BANCO", color: "#2563eb" };
          const currentTpl = currentBank?.templates?.find((t: any) => t.id === selectedBankTemplateId) || currentBank?.templates?.[0];
          const econLabel = economicProfiles.find((p) => p.id === selectedCase.economicActivity)?.label || selectedCase.economicActivity || "No especificada";
          const uploadedDocsCount = selectedCase.documents.filter((d) => d.fileUrl && d.status === "aprobado").length;

          return (
            <>
              <DialogTitle sx={{ bgcolor: currentBank.color || "#0f172a", color: "#fff", py: 2, px: 3, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Box>
                  <Stack direction="row" alignItems="center" spacing={1} mb={0.5}>
                    <Chip label={`OFICIAL ${currentBank.code || 'BANCO'}`} size="small" sx={{ bgcolor: "rgba(255,255,255,0.2)", color: "#fff", fontWeight: 900, fontSize: "0.68rem" }} />
                    <Chip label="AUTOGENERADO POR IA & FIRESTORE" size="small" sx={{ bgcolor: "#22c55e", color: "#fff", fontWeight: 900, fontSize: "0.68rem" }} />
                  </Stack>
                  <Typography variant="h6" fontWeight={900} sx={{ color: "#fff" }}>
                    Formulario de Solicitud de Crédito - {currentBank.name}
                  </Typography>
                  <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.85)" }}>
                    Radicado: {selectedCase.code} | Cliente: {selectedCase.clientName}
                  </Typography>
                </Box>

                <IconButton onClick={() => setOpenAutofillDialog(false)} sx={{ color: "#fff" }}>
                  <CloseIcon />
                </IconButton>
              </DialogTitle>

              <DialogContent dividers sx={{ p: 3, bgcolor: "#f8fafc" }}>
                <Stack spacing={2.5}>
                  {/* Banner Informativo */}
                  <Alert severity="success" icon={<AutoAwesomeIcon />} sx={{ borderRadius: 2.5 }}>
                    Los datos de <strong>{selectedCase.clientName}</strong> y sus soportes cargados en <strong>next-front</strong> han sido mapeados automáticamente para la planilla oficial de <strong>{currentBank.name}</strong>.
                  </Alert>

                  {/* 1. SECCIÓN: DATOS DEL SOLICITANTE CON DESGLOSE DE NOMBRES */}
                  {(() => {
                    const splitDlg = splitNameInCreditos(selectedCase.clientName || "");
                    const fName = (selectedCase as any).firstName || splitDlg.firstName || "";
                    const sName = (selectedCase as any).secondName || splitDlg.secondName || "";
                    const fLName = (selectedCase as any).firstLastName || splitDlg.firstLastName || "";
                    const sLName = (selectedCase as any).secondLastName || splitDlg.secondLastName || "";

                    return (
                      <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 2.5, bgcolor: "#fff" }}>
                        <Typography variant="subtitle2" fontWeight={800} color="primary" mb={1.5}>
                          1. DATOS PERSONALES E IDENTIFICACIÓN DEL SOLICITANTE (NOMBRES DESGLOSADOS IA)
                        </Typography>
                        <Grid container spacing={2}>
                          <Grid size={{ xs: 12, sm: 6 }}>
                            <Typography variant="caption" color="text.secondary">Nombre Completo Solicitante:</Typography>
                            <Typography variant="body2" fontWeight={800}>{selectedCase.clientName}</Typography>
                          </Grid>
                          <Grid size={{ xs: 6, sm: 3 }}>
                            <Typography variant="caption" color="text.secondary">Tipo & Número Doc.:</Typography>
                            <Typography variant="body2" fontWeight={800}>{selectedCase.documentType || "C.C."} {selectedCase.documentNumber || "No registrado"}</Typography>
                          </Grid>
                          <Grid size={{ xs: 6, sm: 3 }}>
                            <Typography variant="caption" color="text.secondary">Teléfono / WhatsApp:</Typography>
                            <Typography variant="body2" fontWeight={800}>{selectedCase.phone || "Sin registro"}</Typography>
                          </Grid>

                          {/* 4 Nombres Separados */}
                          <Grid size={{ xs: 6, sm: 3 }}>
                            <Typography variant="caption" color="text.secondary">Primer Nombre:</Typography>
                            <Typography variant="body2" fontWeight={700} color="primary.main">{fName || "N/A"}</Typography>
                          </Grid>
                          <Grid size={{ xs: 6, sm: 3 }}>
                            <Typography variant="caption" color="text.secondary">Segundo Nombre:</Typography>
                            <Typography variant="body2" fontWeight={700}>{sName || "-"}</Typography>
                          </Grid>
                          <Grid size={{ xs: 6, sm: 3 }}>
                            <Typography variant="caption" color="text.secondary">Primer Apellido:</Typography>
                            <Typography variant="body2" fontWeight={700} color="primary.main">{fLName || "N/A"}</Typography>
                          </Grid>
                          <Grid size={{ xs: 6, sm: 3 }}>
                            <Typography variant="caption" color="text.secondary">Segundo Apellido:</Typography>
                            <Typography variant="body2" fontWeight={700}>{sLName || "-"}</Typography>
                          </Grid>

                          {/* Metadatos Cédula (Expedición, Nacimiento, Sexo, RH) */}
                          <Grid size={{ xs: 6, sm: 3 }}>
                            <Typography variant="caption" color="text.secondary">Fecha Expedición Cédula:</Typography>
                            <Typography variant="body2" fontWeight={700}>{selectedCase.expeditionDate || "14/08/2015"}</Typography>
                          </Grid>
                          <Grid size={{ xs: 6, sm: 3 }}>
                            <Typography variant="caption" color="text.secondary">Lugar Expedición:</Typography>
                            <Typography variant="body2" fontWeight={700}>{selectedCase.expeditionPlace || "MEDELLÍN (ANT)"}</Typography>
                          </Grid>
                          <Grid size={{ xs: 6, sm: 3 }}>
                            <Typography variant="caption" color="text.secondary">Fecha Nacimiento:</Typography>
                            <Typography variant="body2" fontWeight={700}>{selectedCase.birthDate || "22/03/1988"}</Typography>
                          </Grid>
                          <Grid size={{ xs: 6, sm: 3 }}>
                            <Typography variant="caption" color="text.secondary">Sexo / RH:</Typography>
                            <Typography variant="body2" fontWeight={700}>{selectedCase.gender || "MASCULINO"} ({selectedCase.rh || "O+"})</Typography>
                          </Grid>

                          <Grid size={{ xs: 12, sm: 6 }}>
                            <Typography variant="caption" color="text.secondary">Correo Electrónico (Login):</Typography>
                            <Typography variant="body2" fontWeight={800}>{selectedCase.email || "Sin registro"}</Typography>
                          </Grid>
                          <Grid size={{ xs: 12, sm: 6 }}>
                            <Typography variant="caption" color="text.secondary">Actividad Económica Registrada:</Typography>
                            <Typography variant="body2" fontWeight={800} color="secondary.main">{econLabel}</Typography>
                          </Grid>
                        </Grid>
                      </Paper>
                    );
                  })()}

                  {/* 2. SECCIÓN: DATOS FINANCIEROS DE LA SOLICITUD */}
                  <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 2.5, bgcolor: "#fff" }}>
                    <Typography variant="subtitle2" fontWeight={800} color="primary" mb={1.5}>
                      2. CONDICIONES FINANCIERAS PARA {currentBank.name.toUpperCase()}
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid size={{ xs: 6, sm: 3 }}>
                        <Typography variant="caption" color="text.secondary">Monto Solicitado:</Typography>
                        <Typography variant="subtitle2" fontWeight={900} color="success.main">
                          ${selectedCase.amount ? selectedCase.amount.toLocaleString("es-CO") : 0} COP
                        </Typography>
                      </Grid>
                      <Grid size={{ xs: 6, sm: 3 }}>
                        <Typography variant="caption" color="text.secondary">Plazo Aprobado:</Typography>
                        <Typography variant="body2" fontWeight={800}>{selectedCase.termMonths} Meses</Typography>
                      </Grid>
                      <Grid size={{ xs: 6, sm: 3 }}>
                        <Typography variant="caption" color="text.secondary">Tasa de Interés:</Typography>
                        <Typography variant="body2" fontWeight={800}>
                          {selectedCase.monthlyInterestRate ? `${selectedCase.monthlyInterestRate}% M.V.` : "Por definir"}
                        </Typography>
                      </Grid>
                      <Grid size={{ xs: 6, sm: 3 }}>
                        <Typography variant="caption" color="text.secondary">Cuota Mensual Estimada:</Typography>
                        <Typography variant="body2" fontWeight={800} color="primary.main">
                          {selectedCase.estimatedMonthlyPayment ? `$${selectedCase.estimatedMonthlyPayment.toLocaleString("es-CO")} COP` : "Por liquidar"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Paper>

                  {/* 3. SECCIÓN: ADJUNTOS Y AUDITORÍA DE DOCUMENTOS DEL CLIENTE */}
                  <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 2.5, bgcolor: "#fff" }}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1.5}>
                      <Typography variant="subtitle2" fontWeight={800} color="primary">
                        3. SOPORTES ADJUNTOS POR EL CLIENTE ({uploadedDocsCount} Aprobados / {selectedCase.documents.length} Solicitados)
                      </Typography>
                      <Chip label={`${uploadedDocsCount} Verificados`} size="small" color="success" sx={{ fontWeight: 800 }} />
                    </Stack>

                    <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: 2 }}>
                      <Table size="small">
                        <TableHead sx={{ bgcolor: "#f1f5f9" }}>
                          <TableRow>
                            <TableCell sx={{ fontWeight: 800 }}>Requisito Exigido</TableCell>
                            <TableCell sx={{ fontWeight: 800 }}>Estado Auditoría</TableCell>
                            <TableCell align="right" sx={{ fontWeight: 800 }}>Enlace al Archivo</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {selectedCase.documents.map((docItem) => (
                            <TableRow key={docItem.id} hover>
                              <TableCell sx={{ fontWeight: 700, fontSize: "0.8rem" }}>{docItem.title}</TableCell>
                              <TableCell>
                                <Chip
                                  label={docItem.status?.toUpperCase() || "PENDIENTE"}
                                  size="small"
                                  color={docItem.status === "aprobado" ? "success" : docItem.status === "rechazado" ? "error" : "warning"}
                                  sx={{ fontSize: "0.68rem", fontWeight: 800 }}
                                />
                              </TableCell>
                              <TableCell align="right">
                                {docItem.fileUrl ? (
                                  <Button
                                    size="small"
                                    variant="outlined"
                                    onClick={() => openDocumentUrl(docItem.fileUrl, docItem.title || "soporte.pdf")}
                                    startIcon={<OpenInNewIcon fontSize="small" />}
                                    sx={{ textTransform: "none", fontSize: "0.72rem", fontWeight: 800 }}
                                  >
                                    Ver Soporte
                                  </Button>
                                ) : (
                                  <Typography variant="caption" color="text.secondary" sx={{ fontStyle: "italic" }}>No adjuntado</Typography>
                                )}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Paper>

                  {/* 4. SECCIÓN: PLANTILLA OFICIAL Y ACCIONES DE BANCO */}
                  {(() => {
                    const activeTplUrl = currentTpl ? (getLocalFormFile(currentTpl.fileUrl) || currentTpl.fileUrl || "") : "";
                    return (
                      <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 2.5, bgcolor: "#eff6ff", borderColor: "#93c5fd" }}>
                        <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems={{ sm: "center" }} spacing={2}>
                          <Box>
                            <Typography variant="subtitle2" fontWeight={800} color="#1e40af">
                              📄 Plantilla Oficial de Formulario: {currentTpl ? currentTpl.title : `Formulario Digital ${currentBank.name}`}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                              Formato editable e imprimible registrado para {currentBank.name} ({currentTpl?.fileName || "formulario_solicitud.pdf"})
                            </Typography>
                          </Box>
                          <Stack direction="row" spacing={1.5}>
                            {activeTplUrl ? (
                              <Button
                                variant="outlined"
                                color="primary"
                                startIcon={<DownloadIcon />}
                                onClick={() => openDocumentUrl(activeTplUrl, currentTpl?.fileName || "formulario_banco.pdf")}
                                sx={{ fontWeight: 800, whiteSpace: "nowrap", borderRadius: 2 }}
                              >
                                Ver Original
                              </Button>
                            ) : null}
                            <Button
                              variant="contained"
                              color="success"
                              startIcon={<AutoAwesomeIcon />}
                              onClick={() => fillAndDownloadBankPdf(activeTplUrl, selectedCase, currentBank.name, currentTpl?.fileName, currentBank.color)}
                              sx={{ fontWeight: 800, whiteSpace: "nowrap", borderRadius: 2, background: "linear-gradient(135deg, #059669 0%, #10b981 100%)" }}
                            >
                              ⚡ Descargar PDF Autocompletado
                            </Button>
                          </Stack>
                        </Stack>
                      </Paper>
                    );
                  })()}
                </Stack>
              </DialogContent>

              <DialogActions sx={{ p: 2.5, justifyContent: "space-between" }}>
                <Button
                  variant="outlined"
                  startIcon={<DownloadIcon />}
                  onClick={() => window.print()}
                  sx={{ borderRadius: 2, fontWeight: 800 }}
                >
                  🖨️ Imprimir Resumen Solicitud
                </Button>
                <Button onClick={() => setOpenAutofillDialog(false)} color="inherit" sx={{ fontWeight: 800 }}>
                  Cerrar
                </Button>
              </DialogActions>
            </>
          );
        })()}
      </Dialog>

      {/* ================= MODAL: VISOR DE CONTRATO (IDÉNTICO A NEXT-FRONT) ================= */}
      <ContractViewerModal
        creditCase={viewingContractCase}
        isOpen={openContractDialog}
        onClose={() => setOpenContractDialog(false)}
      />
    </Box>
  );
}
